// // import React, { useCallback, useEffect, useMemo, useState } from "react";
// // import { Alert, Badge, Button, Card, Col, Form, Modal, Nav, Row, Spinner, Table } from "react-bootstrap";
// // import { addDoc, collection, deleteDoc, doc, onSnapshot, orderBy, query, serverTimestamp, updateDoc, writeBatch } from "firebase/firestore";
// // import * as XLSX from "xlsx";
// // import { db } from "../../firebase";
// // import { calculateAutoAmount, cleanObject, fmt, fmtTs } from "../../utils/eventUtils";
// // import { generateFundReceipt } from "../../utils/generateFundReceipt";

// // const PAYMENT_METHODS = ["Cash", "PhonePe", "Google Pay", "UPI", "Bank Transfer"];
// // const cmpStr = (a, b) => String(a || "").localeCompare(String(b || ""), undefined, { sensitivity: "base" });
// // const extractFloor = (label) => {
// //   const text = String(label || "").toUpperCase();
// //   if (text.includes("-G") || text.startsWith("G")) return 0;
// //   const numbers = text.match(/\d+/g);
// //   if (!numbers?.length) return null;
// //   const first = Number(numbers[0]);
// //   return Number.isFinite(first) ? (first >= 100 ? Math.floor(first / 100) : first) : null;
// // };
// // const getDate = (value) => {
// //   try {
// //     if (typeof value?.toDate === "function") return value.toDate();
// //     if (value instanceof Date) return value;
// //     const date = typeof value === "string" ? new Date(value) : null;
// //     return date && !Number.isNaN(date.getTime()) ? date : null;
// //   } catch { return null; }
// // };
// // const getAge = (value) => {
// //   if (value == null) return null;
// //   if (typeof value === "number" && Number.isFinite(value)) return value >= 0 ? value : null;
// //   const date = getDate(value);
// //   if (!date) return null;
// //   const today = new Date();
// //   let age = today.getFullYear() - date.getFullYear();
// //   const diff = today.getMonth() - date.getMonth();
// //   if (diff < 0 || (diff === 0 && today.getDate() < date.getDate())) age -= 1;
// //   return age >= 0 ? age : null;
// // };
// // const assembleHouseholdFromResidents = (residents, blockName, flatLabel) => {
// //   const members = [];
// //   const seen = new Set();
// //   (Array.isArray(residents) ? residents : []).filter((r) =>
// //     String(r.unit?.blockName || "").trim() === String(blockName || "").trim() &&
// //     String(r.unit?.flatLabel || "").trim() === String(flatLabel || "").trim()
// //   ).forEach((resident, residentIndex) => {
// //     const name = resident.fullName || resident.displayName || resident.uid || `Resident ${residentIndex + 1}`;
// //     const key = `resident:${resident.uid || name}`;
// //     if (!seen.has(key)) {
// //       seen.add(key);
// //       members.push({ name, age: getAge(resident.age ?? resident.dob), gender: resident.gender || "", relationship: "Resident", isResident: true, uid: resident.uid || null });
// //     }
// //     (Array.isArray(resident.family) ? resident.family : []).forEach((familyMember, index) => {
// //       const familyName = familyMember?.name || `Family ${index + 1}`;
// //       const familyKey = `family:${familyMember?.id || familyName}:${index}`;
// //       if (!seen.has(familyKey)) {
// //         seen.add(familyKey);
// //         members.push({ name: familyName, age: getAge(familyMember?.age ?? familyMember?.dob), gender: familyMember?.gender || "", relationship: familyMember?.relationship || "", isResident: false, id: familyMember?.id || null });
// //       }
// //     });
// //   });
// //   return members;
// // };
// // const classifyCounts = (members, freeAge) => members.reduce((result, member) => {
// //   if (member.isResident || member.age >= 18) result.adults += 1;
// //   else if (member.age != null) {
// //     result.kids += 1;
// //     if (freeAge != null && member.age < freeAge) result.freeKids += 1;
// //   }
// //   return result;
// // }, { adults: 0, kids: 0, freeKids: 0 });
// // // const initialOtherForm = {
// // //   payerType: "resident", type: "Donation", title: "", notes: "", payerName: "", payerUid: "",
// // //   blockName: "", floorNumber: "", flatLabel: "", amount: "", receiptNo: "", method: "",
// // //   receivedByUid: "", receivedByName: "",
// // // };

// // const initialOtherForm = {
// //   payerType: "resident",
// //   type: "Donation",

// //   residentSelection: "",

// //   payerName: "",

// //   title: "",
// //   notes: "",
// //   payerUid: "",

// //   blockName: "",
// //   floorNumber: "",
// //   flatLabel: "",

// //   amount: "",
// //   receiptNo: "",
// //   method: "",

// //   receivedByUid: "",
// //   receivedByName: "",
// // };
// // const buildFloorOptions = (community, residents, blockName) => {
// //   if (!blockName) return [];
// //   const floors = new Set();
// //   const blocks = Array.isArray(community?.blocks) ? community.blocks : [];
// //   const block = blocks.find((item, index) => String(item?.name || item?.blockName || `Block-${index + 1}`).trim() === blockName);
// //   if (block?.hasGround) floors.add("0");
// //   for (let floor = 1; floor <= Number(block?.floors || 0); floor += 1) floors.add(String(floor));
// //   (Array.isArray(block?.flats) ? block.flats : []).forEach((flat) => { const floor = extractFloor(flat); if (floor != null) floors.add(String(floor)); });
// //   residents.forEach((resident) => {
// //     if (String(resident.unit?.blockName || "").trim() !== blockName) return;
// //     const supplied = resident.unit?.floorNumber;
// //     const floor = supplied !== "" && supplied != null ? Number(supplied) : extractFloor(resident.unit?.flatLabel);
// //     if (Number.isFinite(floor)) floors.add(String(floor));
// //   });
// //   return [...floors].sort((a, b) => Number(a) - Number(b)).map((value) => ({ value, label: value === "0" ? "Ground Floor" : `Floor ${value}` }));
// // };
// // const buildFlatOptions = (community, residents, blockName, floorNumber) => {
// //   if (!blockName || floorNumber === "") return [];
// //   const flats = new Set();
// //   const blocks = Array.isArray(community?.blocks) ? community.blocks : [];
// //   const block = blocks.find((item, index) => String(item?.name || item?.blockName || `Block-${index + 1}`).trim() === blockName);
// //   (Array.isArray(block?.flats) ? block.flats : []).forEach((flat) => {
// //     if (String(extractFloor(flat) ?? "") === String(floorNumber)) flats.add(String(flat).trim());
// //   });
// //   residents.forEach((resident) => {
// //     if (String(resident.unit?.blockName || "").trim() !== blockName) return;
// //     const flat = String(resident.unit?.flatLabel || "").trim();
// //     const supplied = resident.unit?.floorNumber;
// //     const floor = supplied !== "" && supplied != null ? String(supplied) : String(extractFloor(flat) ?? "");
// //     if (floor === String(floorNumber) && flat) flats.add(flat);
// //   });
// //   return [...flats].sort(cmpStr).map((value) => ({ value, label: value }));
// // };

// // export default function FundsPanel({ communityId, event, community, residents = [], canEditFunds }) {
// //   const eventId = event?.id;
// //   const entryFee = event?.entryFee || {};
// //   const adultFee = Number(entryFee.adult) || 0;
// //   const childFee = Number(entryFee.child) || 0;
// //   const freeAge = entryFee.freeBelowAge == null ? null : Number(entryFee.freeBelowAge);
// //   const familyFee = Number(entryFee.familyFee) || 0;
// //   const isFamilyMode = event?.collectionMode === "family";
// //   const createInitialResidentForm = useCallback(() => ({ blockName: "", floorNumber: "", flatLabel: "", amountMode: isFamilyMode ? "manual" : "auto", amount: isFamilyMode && familyFee > 0 ? String(familyFee) : "", receiptNo: "", method: "", receivedByUid: "", receivedByName: "" }), [familyFee, isFamilyMode]);

// //   const [funds, setFunds] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState("");
// //   const [innerTab, setInnerTab] = useState("resident");
// //   const [residentForm, setResidentForm] = useState(createInitialResidentForm);
// //   const [otherForm, setOtherForm] = useState(initialOtherForm);
// //   const [counts, setCounts] = useState({ adults: 0, kids: 0, freeKids: 0 });
// //   const [householdMembers, setHouseholdMembers] = useState([]);
// //   const [householdLoading, setHouseholdLoading] = useState(false);
// //   const [showFamilyTable, setShowFamilyTable] = useState(false);
// //   const [uploading, setUploading] = useState(false);
// //   const [copyingReceiptLink, setCopyingReceiptLink] = useState(false);
// //   const [receiptLinkCopied, setReceiptLinkCopied] = useState(false);
// //   const [showEdit, setShowEdit] = useState(false);
// //   const [savingEdit, setSavingEdit] = useState(false);
// //   const [showAddFunds, setShowAddFunds] = useState(false);
// //   const [editFund, setEditFund] = useState(null);
  
// //   const [editForm, setEditForm] = useState({ amount: "", receiptNo: "", method: "", blockName: "", floorNumber: "", flatLabel: "", receivedByUid: "", receivedByName: "", payerType: "other", payerName: "", otherType: "Donation", otherTitle: "", otherNotes: "" });

// //   const [selectedFunds, setSelectedFunds] =
// //     useState([]);

// //   const [deleting, setDeleting] =
// //     useState(false);

// //   const handleSelectAllFunds = useCallback(
// //     (fundsList) => {
// //       const safeFundsList = Array.isArray(fundsList)
// //         ? fundsList
// //         : [];

// //       const fundIds = safeFundsList
// //         .map((fund) => fund?.id)
// //         .filter(Boolean);

// //       if (fundIds.length === 0) {
// //         return;
// //       }

// //       setSelectedFunds((previous) => {
// //         const safePrevious = Array.isArray(previous)
// //           ? previous
// //           : [];

// //         const allFundsSelected = fundIds.every(
// //           (fundId) =>
// //             safePrevious.includes(fundId)
// //         );

// //         if (allFundsSelected) {
// //           return safePrevious.filter(
// //             (selectedFundId) =>
// //               !fundIds.includes(selectedFundId)
// //           );
// //         }

// //         return Array.from(
// //           new Set([
// //             ...safePrevious,
// //             ...fundIds,
// //           ])
// //         );
// //       });
// //     },
// //     []
// //   );

// //   const handleSelectFund = useCallback((fundId) => {
// //     if (!fundId) {
// //       return;
// //     }

// //     setSelectedFunds((previous) => {
// //       const safePrevious = Array.isArray(previous)
// //         ? previous
// //         : [];

// //       if (safePrevious.includes(fundId)) {
// //         return safePrevious.filter(
// //           (selectedFundId) =>
// //             selectedFundId !== fundId
// //         );
// //       }

// //       return [...safePrevious, fundId];
// //     });
// //   }, []);


// //   const handleDeleteSelected = useCallback(
// //     async () => {
// //       const safeSelectedFunds =
// //         Array.isArray(selectedFunds)
// //           ? selectedFunds.filter(Boolean)
// //           : [];

// //       if (!canEditFunds) {
// //         alert("Not allowed for your role.");
// //         return;
// //       }

// //       if (!eventId) {
// //         alert("Event ID is missing.");
// //         return;
// //       }

// //       if (safeSelectedFunds.length === 0) {
// //         alert("Select at least one fund.");
// //         return;
// //       }

// //       const confirmed = window.confirm(
// //         `Delete ${safeSelectedFunds.length} selected fund record(s)?`
// //       );

// //       if (!confirmed) {
// //         return;
// //       }

// //       const deleteText = window.prompt(
// //         'Type DELETE to continue'
// //       );

// //       if (
// //         String(deleteText || "").trim() !==
// //         "DELETE"
// //       ) {
// //         alert("Delete cancelled.");
// //         return;
// //       }

// //       try {
// //         setDeleting(true);

// //         for (
// //           let start = 0;
// //           start < safeSelectedFunds.length;
// //           start += 450
// //         ) {
// //           const batch = writeBatch(db);

// //           const selectedChunk =
// //             safeSelectedFunds.slice(
// //               start,
// //               start + 450
// //             );

// //           selectedChunk.forEach((fundId) => {
// //             batch.delete(
// //               doc(
// //                 db,
// //                 "events",
// //                 eventId,
// //                 "funds",
// //                 fundId
// //               )
// //             );
// //           });

// //           await batch.commit();
// //         }

// //         setSelectedFunds([]);

// //         alert(
// //           `${safeSelectedFunds.length} fund record(s) deleted successfully.`
// //         );
// //       } catch (deleteError) {
// //         console.error(
// //           "Delete selected funds error:",
// //           deleteError?.code,
// //           deleteError?.message,
// //           deleteError
// //         );

// //         alert(
// //           deleteError?.message ||
// //           "Failed to delete the selected funds."
// //         );
// //       } finally {
// //         setDeleting(false);
// //       }
// //     },
// //     [
// //       canEditFunds,
// //       eventId,
// //       selectedFunds,
// //     ]
// //   );


// //   const residentNameByUid = useCallback((uid, fallback = "") => {
// //     if (!uid) return fallback;
// //     const resident = residents.find((item) => item.uid === uid);
// //     return resident?.fullName || resident?.displayName || resident?.name || fallback || uid;
// //   }, [residents]);
// //   const committeeOptions = useMemo(() => {
// //     const unique = new Map();
// //     (Array.isArray(event?.committee) ? event.committee : []).forEach((member) => {
// //       const uid = String(member?.uid || "").trim();
// //       const name = String(member?.residentName || member?.name || member?.fullName || member?.displayName || "").trim();
// //       const value = uid ? `uid:${uid}` : name ? `name:${name}` : "";
// //       if (value && !unique.has(value)) unique.set(value, { value, label: uid ? residentNameByUid(uid, name || uid) : name });
// //     });
// //     return [...unique.values()].sort((a, b) => cmpStr(a.label, b.label));
// //   }, [event?.committee, residentNameByUid]);
// //   const chooseCollector = (value, setter) => setter((previous) => value.startsWith("uid:") ? { ...previous, receivedByUid: value.slice(4), receivedByName: residentNameByUid(value.slice(4), value.slice(4)) } : value.startsWith("name:") ? { ...previous, receivedByUid: "", receivedByName: value.slice(5) } : { ...previous, receivedByUid: "", receivedByName: "" });
// //   const collectorValue = (form) => form.receivedByUid ? `uid:${form.receivedByUid}` : form.receivedByName ? `name:${form.receivedByName}` : "";

// //   const blockOptions = useMemo(() => {
// //     const values = new Set();
// //     (Array.isArray(community?.blocks) ? community.blocks : []).forEach((block, index) => values.add(String(block?.name || block?.blockName || `Block-${index + 1}`).trim()));
// //     residents.forEach((resident) => { const name = String(resident.unit?.blockName || "").trim(); if (name) values.add(name); });
// //     return [...values].filter(Boolean).sort(cmpStr);
// //   }, [community, residents]);
// //   const residentFloorOptions = useMemo(() => buildFloorOptions(community, residents, residentForm.blockName), [community, residents, residentForm.blockName]);
// //   const residentFlatOptions = useMemo(() => buildFlatOptions(community, residents, residentForm.blockName, residentForm.floorNumber), [community, residents, residentForm.blockName, residentForm.floorNumber]);
// //   const otherFloorOptions = useMemo(() => buildFloorOptions(community, residents, otherForm.blockName), [community, residents, otherForm.blockName]);
// //   const otherFlatOptions = useMemo(() => buildFlatOptions(community, residents, otherForm.blockName, otherForm.floorNumber), [community, residents, otherForm.blockName, otherForm.floorNumber]);
// //   const selectedOtherResident = useMemo(() => residents.find((resident) => String(resident.unit?.blockName || "").trim() === otherForm.blockName && String(resident.unit?.flatLabel || "").trim() === otherForm.flatLabel) || null, [otherForm.blockName, otherForm.flatLabel, residents]);
// //   const selectedOtherResidentName = selectedOtherResident ? residentNameByUid(selectedOtherResident.uid, selectedOtherResident.fullName || "") : "";
// // // const selectedFlatResidents = useMemo(() => {
// // //   if (
// // //     !otherForm.blockName ||
// // //     otherForm.floorNumber === "" ||
// // //     !otherForm.flatLabel
// // //   ) {
// // //     return [];
// // //   }

// // //   return residents
// // //     .filter((resident) => {
// // //       const residentBlock = String(
// // //         resident.unit?.blockName || ""
// // //       ).trim();

// // //       const residentFlat = String(
// // //         resident.unit?.flatLabel || ""
// // //       ).trim();

// // //       return (
// // //         residentBlock === otherForm.blockName &&
// // //         residentFlat === otherForm.flatLabel
// // //       );
// // //     })
// // //     .map((resident, index) => {
// // //       const uid = String(
// // //         resident.uid || resident.id || ""
// // //       ).trim();

// // //       const name = String(
// // //         resident.fullName ||
// // //           resident.displayName ||
// // //           resident.name ||
// // //           `Resident ${index + 1}`
// // //       ).trim();

// // //       return {
// // //         value: uid ? `resident:${uid}` : `resident-name:${name}`,
// // //         uid,
// // //         name,
// // //       };
// // //     })
// // //     .sort((first, second) =>
// // //       cmpStr(first.name, second.name)
// // //     );
// // // }, [
// // //   otherForm.blockName,
// // //   otherForm.floorNumber,
// // //   otherForm.flatLabel,
// // //   residents,
// // // ]);
// //   const selectedFlatResidents = useMemo(() => {
// //   const selectedBlock = String(
// //     otherForm.blockName || ""
// //   ).trim();

// //   const selectedFloor = String(
// //     otherForm.floorNumber ?? ""
// //   ).trim();

// //   const selectedFlat = String(
// //     otherForm.flatLabel || ""
// //   ).trim();

// //   if (
// //     !selectedBlock ||
// //     selectedFloor === "" ||
// //     !selectedFlat
// //   ) {
// //     return [];
// //   }

// //   const matchedResidents = residents.filter(
// //     (resident) => {
// //       const residentBlock = String(
// //         resident?.unit?.blockName ||
// //           resident?.blockName ||
// //           ""
// //       ).trim();

// //       const residentFlat = String(
// //         resident?.unit?.flatLabel ||
// //           resident?.flatLabel ||
// //           ""
// //       ).trim();

// //       const suppliedFloor =
// //         resident?.unit?.floorNumber ??
// //         resident?.floorNumber;

// //       const calculatedFloor =
// //         suppliedFloor !== undefined &&
// //         suppliedFloor !== null &&
// //         String(suppliedFloor).trim() !== ""
// //           ? String(suppliedFloor).trim()
// //           : String(
// //               extractFloor(residentFlat) ?? ""
// //             );

// //       return (
// //         residentBlock === selectedBlock &&
// //         residentFlat === selectedFlat &&
// //         calculatedFloor === selectedFloor
// //       );
// //     }
// //   );

// //   const uniqueResidents = new Map();

// //   matchedResidents.forEach((resident, index) => {
// //     const uid = String(
// //       resident?.uid ||
// //         resident?.id ||
// //         ""
// //     ).trim();

// //     const name = String(
// //       resident?.fullName ||
// //         resident?.displayName ||
// //         resident?.name ||
// //         `Resident ${index + 1}`
// //     ).trim();

// //     const value = uid
// //       ? `resident:${uid}`
// //       : `resident-name:${name}`;

// //     if (!uniqueResidents.has(value)) {
// //       uniqueResidents.set(value, {
// //         value,
// //         uid,
// //         name,
// //       });
// //     }
// //   });

// //   return Array.from(uniqueResidents.values()).sort(
// //     (first, second) =>
// //       cmpStr(first.name, second.name)
// //   );
// // }, [
// //   otherForm.blockName,
// //   otherForm.floorNumber,
// //   otherForm.flatLabel,
// //   residents,
// // ]);

// // const otherFundDetailLabel = useMemo(() => {
// //   switch (otherForm.type) {
// //     case "Donation":
// //       return "Donation Purpose";

// //     case "Sponsor":
// //       return "Sponsor Name / Purpose";

// //     case "Gift":
// //       return "Gift Name / Purpose";

// //     case "Sale":
// //       return "Sale Item / Purpose";

// //     case "Other":
// //       return "Purpose / Description";

// //     default:
// //       return "Fund Details";
// //   }
// // }, [otherForm.type]);

// //   useEffect(() => {
// //     if (!eventId) { setError("Missing eventId."); setLoading(false); return undefined; }
// //     return onSnapshot(query(collection(db, "events", eventId, "funds"), orderBy("createdAt", "desc")), (snapshot) => { setFunds(snapshot.docs.map((item) => ({ id: item.id, ...item.data() }))); setLoading(false); }, (snapshotError) => { setError(snapshotError?.message || "Failed to load funds."); setLoading(false); });
// //   }, [eventId]);
// //   useEffect(() => {
// //     if (!residentForm.blockName || !residentForm.flatLabel) { setCounts({ adults: 0, kids: 0, freeKids: 0 }); setHouseholdMembers([]); return; }
// //     setHouseholdLoading(true);
// //     const members = assembleHouseholdFromResidents(residents, residentForm.blockName, residentForm.flatLabel);
// //     setHouseholdMembers(members); setCounts(classifyCounts(members, freeAge)); setHouseholdLoading(false);
// //   }, [freeAge, residentForm.blockName, residentForm.flatLabel, residents]);
// //   const autoAmountResidents = useMemo(() => isFamilyMode ? familyFee : calculateAutoAmount({ adultFee, childFee, adults: counts.adults, kids: counts.kids, freeKids: counts.freeKids }), [adultFee, childFee, counts, familyFee, isFamilyMode]);
// //   useEffect(() => { setResidentForm((previous) => previous.amountMode === "auto" && !isFamilyMode ? { ...previous, amount: autoAmountResidents ? String(autoAmountResidents) : "" } : previous); }, [autoAmountResidents, isFamilyMode]);

// //   const saveFund = async (payload) => addDoc(collection(db, "events", eventId, "funds"), cleanObject({ ...payload, communityId: String(communityId || ""), eventId, createdAt: serverTimestamp() }));
// //   const openAddFundsModal = () => {
// //   setInnerTab("resident");
// //   setShowAddFunds(true);
// // };

// // const closeAddFundsModal = () => {
// //   if (uploading) {
// //     return;
// //   }

// //   setShowAddFunds(false);
// // };
  
// //   const addResidentFund = async () => {
// //     if (!canEditFunds || !eventId) return alert("Not allowed or event is missing.");
// //     const f = residentForm;
// //     if (!f.blockName || f.floorNumber === "" || !f.flatLabel || !f.method || (!f.receivedByUid && !f.receivedByName)) return alert("Complete all required resident fund fields.");
// //     const amount = f.amountMode === "manual" ? Number(f.amount) : autoAmountResidents;
// //     if (!Number.isFinite(amount) || amount <= 0) return alert("Amount must be greater than 0.");
// //     try {
// //       await saveFund({ sourceType: "resident", payerType: "resident", blockName: f.blockName.trim(), floorNumber: Number(f.floorNumber), flatLabel: f.flatLabel.trim(), amount, receiptNo: f.receiptNo.trim(), method: f.method, receivedByUid: f.receivedByUid || undefined, receivedByName: residentNameByUid(f.receivedByUid, f.receivedByName), amountMode: isFamilyMode ? "manual" : f.amountMode, householdCounts: counts, entryFeeUsed: { adult: adultFee, child: childFee, freeBelowAge: freeAge } });
// //       setResidentForm(createInitialResidentForm()); setCounts({ adults: 0, kids: 0, freeKids: 0 }); setHouseholdMembers([]); setShowAddFunds(false);
// //     } catch (e) { alert(e?.message || "Failed to add resident fund."); }
// //   };
  
// // //  const addOtherFund = async () => {
// // //   if (!canEditFunds) {
// // //     alert("You are not allowed to add funds.");
// // //     return;
// // //   }

// // //   if (!eventId) {
// // //     alert("Event ID is missing.");
// // //     return;
// // //   }

// // //   const form = otherForm;

// // //   if (!form.type) {
// // //     alert("Select a fund type.");
// // //     return;
// // //   }

// // //   if (!String(form.title || "").trim()) {
// // //     alert(`Enter ${otherFundDetailLabel}.`);
// // //     return;
// // //   }

// // //   if (form.payerType === "resident") {
// // //     if (
// // //       !form.blockName ||
// // //       form.floorNumber === "" ||
// // //       !form.flatLabel
// // //     ) {
// // //       alert("Select resident block, floor and flat.");
// // //       return;
// // //     }

// // //     if (!selectedOtherResident) {
// // //       alert(
// // //         "No resident was found for the selected block and flat."
// // //       );
// // //       return;
// // //     }
// // //   }

// // //   if (
// // //     form.payerType === "other" &&
// // //     !String(form.payerName || "").trim()
// // //   ) {
// // //     alert("Enter payer, donor or sponsor name.");
// // //     return;
// // //   }

// // //   if (!form.method) {
// // //     alert("Select pay mode.");
// // //     return;
// // //   }

// // //   if (!form.receivedByUid && !form.receivedByName) {
// // //     alert("Select received by.");
// // //     return;
// // //   }

// // //   const amount = Number(form.amount);

// // //   if (!Number.isFinite(amount) || amount <= 0) {
// // //     alert("Amount must be greater than 0.");
// // //     return;
// // //   }

// // //   // const paidByName =
// // //   //   form.payerType === "resident"
// // //   //     ? selectedOtherResidentName ||
// // //   //       selectedOtherResident?.fullName ||
// // //   //       selectedOtherResident?.displayName ||
// // //   //       selectedOtherResident?.name ||
// // //   //       form.flatLabel
// // //   //     : String(form.payerName || "").trim();
// // //   let paidByName = "";

// // // if (form.payerType === "resident") {
// // //   if (
// // //     form.residentEntryType === "registered"
// // //   ) {
// // //     paidByName =
// // //       selectedOtherResidentName ||
// // //       form.flatLabel;
// // //   } else {
// // //     paidByName = form.payerName.trim();
// // //   }
// // // } else {
// // //   paidByName = form.payerName.trim();
// // // }

// // //   try {
// // //     await saveFund({
// // //       sourceType: "other",
// // //       payerType: form.payerType,

// // //       otherType: form.type,
// // //       otherTitle: String(form.title || "").trim(),
// // //       otherNotes:
// // //         String(form.notes || "").trim() || undefined,

// // //       blockName:
// // //         form.payerType === "resident"
// // //           ? String(form.blockName || "").trim()
// // //           : undefined,

// // //       floorNumber:
// // //         form.payerType === "resident"
// // //           ? Number(form.floorNumber)
// // //           : undefined,

// // //       flatLabel:
// // //         form.payerType === "resident"
// // //           ? String(form.flatLabel || "").trim()
// // //           : undefined,

// // //       payerUid:
// // //         form.payerType === "resident"
// // //           ? selectedOtherResident?.uid || undefined
// // //           : undefined,

// // //       paidByName,

// // //       amount,

// // //       receiptNo: String(form.receiptNo || "").trim(),

// // //       method: form.method,

// // //       receivedByUid:
// // //         form.receivedByUid || undefined,

// // //       receivedByName: residentNameByUid(
// // //         form.receivedByUid,
// // //         form.receivedByName
// // //       ),

// // //       amountMode: "manual",
// // //     });

// // //     setOtherForm({
// // //       ...initialOtherForm,
// // //       payerType: form.payerType,
// // //     });

// // //     setShowAddFunds(false);

// // //     alert(`${form.type} fund added successfully.`);
// // //   } catch (saveError) {
// // //     console.error(
// // //       "Add other fund error:",
// // //       saveError?.code,
// // //       saveError?.message,
// // //       saveError
// // //     );

// // //     alert(
// // //       saveError?.message ||
// // //         "Failed to add the other fund."
// // //     );
// // //   }
// // // };
 
// // const addOtherFund = async () => {
// //   if (!canEditFunds) {
// //     alert("You are not allowed to add funds.");
// //     return;
// //   }

// //   if (!eventId) {
// //     alert("Event ID is missing.");
// //     return;
// //   }

// //   const form = otherForm;

// //   const isResidentPayer =
// //     form.payerType === "resident";

// //   const isOtherResident =
// //     form.residentSelection === "other";

// //   if (!form.type) {
// //     alert("Select a fund type.");
// //     return;
// //   }

// //   if (!String(form.title || "").trim()) {
// //     alert(`Enter ${otherFundDetailLabel}.`);
// //     return;
// //   }

// //   if (isResidentPayer) {
// //     if (
// //       !form.blockName ||
// //       form.floorNumber === "" ||
// //       !form.flatLabel
// //     ) {
// //       alert(
// //         "Select resident block, floor and flat."
// //       );
// //       return;
// //     }

// //     if (!form.residentSelection) {
// //       alert(
// //         "Select a registered resident or Other Name."
// //       );
// //       return;
// //     }

// //     if (
// //       isOtherResident &&
// //       !String(form.payerName || "").trim()
// //     ) {
// //       alert("Enter resident name.");
// //       return;
// //     }
// //   } else {
// //     if (
// //       !String(form.payerName || "").trim()
// //     ) {
// //       alert(
// //         "Enter payer, donor or sponsor name."
// //       );
// //       return;
// //     }
// //   }

// //   if (!form.method) {
// //     alert("Select pay mode.");
// //     return;
// //   }

// //   if (
// //     !form.receivedByUid &&
// //     !form.receivedByName
// //   ) {
// //     alert("Select received by.");
// //     return;
// //   }

// //   const amount = Number(form.amount);

// //   if (
// //     !Number.isFinite(amount) ||
// //     amount <= 0
// //   ) {
// //     alert("Amount must be greater than 0.");
// //     return;
// //   }

// //   const paidByName = String(
// //   form.payerName ||
// //     selectedOtherResidentName ||
// //     ""
// // ).trim();

// // if (!paidByName) {
// //   alert("Payer or resident name is missing.");
// //   return;
// // }

// //   const payerUid =
// //     isResidentPayer &&
// //     !isOtherResident
// //       ? form.payerUid || undefined
// //       : undefined;

// //   try {
// //     await saveFund({
// //       sourceType: "other",

// //       payerType: form.payerType,

// //       residentSelection: isResidentPayer
// //         ? form.residentSelection
// //         : undefined,

// //       otherType: form.type,

// //       otherTitle: String(
// //         form.title || ""
// //       ).trim(),

// //       otherNotes:
// //         String(form.notes || "").trim() ||
// //         undefined,

// //       blockName: isResidentPayer
// //         ? String(
// //             form.blockName || ""
// //           ).trim()
// //         : undefined,

// //       floorNumber: isResidentPayer
// //         ? Number(form.floorNumber)
// //         : undefined,

// //       flatLabel: isResidentPayer
// //         ? String(
// //             form.flatLabel || ""
// //           ).trim()
// //         : undefined,

// //       payerUid,

// //       paidByName,

// //       amount,

// //       receiptNo: String(
// //         form.receiptNo || ""
// //       ).trim(),

// //       method: form.method,

// //       receivedByUid:
// //         form.receivedByUid || undefined,

// //       receivedByName: residentNameByUid(
// //         form.receivedByUid,
// //         form.receivedByName
// //       ),

// //       amountMode: "manual",
// //     });

// //     setOtherForm({
// //       ...initialOtherForm,
// //       payerType: form.payerType,
// //       type: form.type,
// //     });

// //     setShowAddFunds(false);

// //     alert(
// //       `${form.type} fund added successfully.`
// //     );
// //   } catch (error) {
// //     console.error(
// //       "Add other fund error:",
// //       error
// //     );

// //     alert(
// //       error?.message ||
// //         "Failed to add the other fund."
// //     );
// //   }
// // };

// //   const deleteFund = async (id) => { if (canEditFunds && window.confirm("Delete this fund entry?")) await deleteDoc(doc(db, "events", eventId, "funds", id)); };


// //   // const copyEventReceiptLink = async () => {
// //   //   if (!eventId || !communityId) return alert("Event or Community ID is missing.");
// //   //   setCopyingReceiptLink(true);
// //   //   try { await navigator.clipboard.writeText(`${window.location.origin}/download-receipt/${encodeURIComponent(eventId)}`); setReceiptLinkCopied(true); setTimeout(() => setReceiptLinkCopied(false), 3000); }
// //   //   catch (e) { alert(e?.message || "Unable to copy link."); }
// //   //   finally { setCopyingReceiptLink(false); }
// //   // };

// //   const copyEventReceiptLink = useCallback(async () => {
// //   const safeEventId = String(eventId || "").trim();
// //   const safeCommunityId = String(communityId || "").trim();

// //   if (!safeEventId) {
// //     alert("Event ID is missing.");
// //     return;
// //   }

// //   if (!safeCommunityId) {
// //     alert("Community ID is missing.");
// //     return;
// //   }

// //   setCopyingReceiptLink(true);
// //   setReceiptLinkCopied(false);

// //   try {
// //     const receiptUrl = new URL(
// //       `/download-receipt/${encodeURIComponent(safeEventId)}`,
// //       window.location.origin
// //     );

// //     receiptUrl.searchParams.set(
// //       "communityId",
// //       safeCommunityId
// //     );

// //     const finalReceiptUrl = receiptUrl.toString();

// //     if (
// //       navigator.clipboard &&
// //       window.isSecureContext
// //     ) {
// //       await navigator.clipboard.writeText(
// //         finalReceiptUrl
// //       );
// //     } else {
// //       const temporaryTextArea =
// //         document.createElement("textarea");

// //       temporaryTextArea.value =
// //         finalReceiptUrl;

// //       temporaryTextArea.setAttribute(
// //         "readonly",
// //         ""
// //       );

// //       temporaryTextArea.style.position =
// //         "fixed";

// //       temporaryTextArea.style.left =
// //         "-9999px";

// //       temporaryTextArea.style.top =
// //         "-9999px";

// //       document.body.appendChild(
// //         temporaryTextArea
// //       );

// //       temporaryTextArea.focus();
// //       temporaryTextArea.select();

// //       temporaryTextArea.setSelectionRange(
// //         0,
// //         temporaryTextArea.value.length
// //       );

// //       const copySucceeded =
// //         document.execCommand("copy");

// //       document.body.removeChild(
// //         temporaryTextArea
// //       );

// //       if (!copySucceeded) {
// //         throw new Error(
// //           "The browser could not copy the receipt link."
// //         );
// //       }
// //     }

// //     console.log(
// //       "Receipt link copied:",
// //       finalReceiptUrl
// //     );

// //     setReceiptLinkCopied(true);

// //     window.setTimeout(() => {
// //       setReceiptLinkCopied(false);
// //     }, 3000);
// //   } catch (copyError) {
// //     console.error(
// //       "Copy receipt link error:",
// //       copyError?.message,
// //       copyError
// //     );

// //     alert(
// //       copyError?.message ||
// //         "Unable to copy the receipt link."
// //     );
// //   } finally {
// //     setCopyingReceiptLink(false);
// //   }
// // }, [communityId, eventId]);
// //   // =================
// //   // const downloadResidentTemplate = () => {
// //   //   const sheet = XLSX.utils.json_to_sheet([{ blockName: "A", flatLabel: "A-101", adults: 2, kids: 1, freeKids: 0, amountMode: isFamilyMode ? "manual" : "auto", amount: isFamilyMode ? familyFee : "", receiptNo: "RCPT-001", method: "Cash", receivedByUid: "", receivedByName: "Collector Name" }]);
// //   //   const book = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(book, sheet, "Residents"); XLSX.writeFile(book, `ResidentFundsTemplate_${event?.name || "Event"}.xlsx`);
// //   // };

// //   const downloadResidentTemplate = () => {
// //   const headers = [
// //     "blockName",
// //     "flatLabel",
// //     "paidByName",
// //     "adults",
// //     "kids",
// //     "freeKids",
// //     "amountMode",
// //     "amount",
// //     "receiptNo",
// //     "method",
// //     "receivedByUid",
// //     "receivedByName",
// //   ];

// //   const exampleRow = {
// //     blockName: "A",
// //     flatLabel: "A-101",
// //     paidByName: "Resident or Family Name",
// //     adults: 2,
// //     kids: 1,
// //     freeKids: 0,
// //     amountMode: isFamilyMode ? "manual" : "auto",
// //     amount: isFamilyMode ? familyFee : "",
// //     receiptNo: "RCPT-001",
// //     method: "Cash",
// //     receivedByUid: "",
// //     receivedByName: "Committee Member Name",
// //   };

// //   const worksheet = XLSX.utils.json_to_sheet(
// //     [exampleRow],
// //     { header: headers }
// //   );

// //   worksheet["!cols"] = [
// //     { wch: 14 },
// //     { wch: 14 },
// //     { wch: 30 },
// //     { wch: 10 },
// //     { wch: 10 },
// //     { wch: 12 },
// //     { wch: 14 },
// //     { wch: 14 },
// //     { wch: 18 },
// //     { wch: 18 },
// //     { wch: 24 },
// //     { wch: 30 },
// //   ];

// //   const workbook = XLSX.utils.book_new();

// //   XLSX.utils.book_append_sheet(
// //     workbook,
// //     worksheet,
// //     "Residents"
// //   );

// //   const safeEventName = String(
// //     event?.name || event?.title || "Event"
// //   )
// //     .replace(/[\\/:*?"<>|]/g, "_")
// //     .trim();

// //   XLSX.writeFile(
// //     workbook,
// //     `ResidentFundsTemplate_${safeEventName}.xlsx`
// //   );
// // };
  
// //   const handleResidentBulkUpload = async (file) => {
// //     if (!file || !canEditFunds || !eventId) return;
// //     setUploading(true);
// //     try {
// //       const workbook = XLSX.read(await file.arrayBuffer(), { type: "array" });
// //       const sheet = workbook.Sheets.Residents || workbook.Sheets[workbook.SheetNames[0]];
// //       const rows = sheet ? XLSX.utils.sheet_to_json(sheet, { defval: "" }) : [];
// //       const payloads = rows.map((row) => {
// //         const amountMode = String(row.amountMode || (isFamilyMode ? "manual" : "auto")).toLowerCase() === "manual" ? "manual" : "auto";
// //         const amount = isFamilyMode || amountMode === "manual" ? Number(row.amount || familyFee) : calculateAutoAmount({ adultFee, childFee, adults: Number(row.adults || 0), kids: Number(row.kids || 0), freeKids: Number(row.freeKids || 0) });
// //         const paidByName = String(
// //   row.paidByName || ""
// // ).trim();
// //         if (!row.blockName || !row.flatLabel || !Number.isFinite(amount) || amount <= 0) return null;
// //         return cleanObject({ sourceType: "resident", payerType: "resident", communityId: String(communityId || ""), eventId, blockName: String(row.blockName).trim(), floorNumber: extractFloor(row.flatLabel), flatLabel: String(row.flatLabel).trim(), paidByName: paidByName || undefined, amount, receiptNo: String(row.receiptNo || "").trim(), method: String(row.method || "").trim(), receivedByUid: String(row.receivedByUid || "").trim() || undefined, receivedByName: residentNameByUid(String(row.receivedByUid || "").trim(), String(row.receivedByName || "").trim()), amountMode, createdAt: serverTimestamp() });
// //       }).filter(Boolean);
// //       for (let start = 0; start < payloads.length; start += 450) { const batch = writeBatch(db); payloads.slice(start, start + 450).forEach((payload) => batch.set(doc(collection(db, "events", eventId, "funds")), payload)); await batch.commit(); }
// //       alert(`Uploaded: ${payloads.length}. Skipped: ${rows.length - payloads.length}.`);
// //     } catch (e) { alert(e?.message || "Failed to upload."); }
// //     finally { setUploading(false); }
// //   };
// //   const openEdit = (fund) => { setEditFund(fund); setEditForm({ amount: String(fund.amount ?? ""), receiptNo: fund.receiptNo || "", method: fund.method || "", blockName: fund.blockName || "", floorNumber: String(fund.floorNumber ?? extractFloor(fund.flatLabel) ?? ""), flatLabel: fund.flatLabel || "", receivedByUid: fund.receivedByUid || "", receivedByName: fund.receivedByName || "", payerType: fund.payerType || (fund.blockName ? "resident" : "other"), payerName: fund.paidByName || "", otherType: fund.otherType || "Donation", otherTitle: fund.otherTitle || "", otherNotes: fund.otherNotes || "" }); setShowEdit(true); };
// //   const saveEdit = async () => {
// //     const amount = Number(editForm.amount); if (!editFund?.id || !Number.isFinite(amount) || amount <= 0) return alert("Enter a valid amount.");
// //     setSavingEdit(true);
// //     try { await updateDoc(doc(db, "events", eventId, "funds", editFund.id), cleanObject({ amount, receiptNo: editForm.receiptNo.trim(), method: editForm.method, blockName: editForm.blockName || undefined, floorNumber: editForm.floorNumber === "" ? undefined : Number(editForm.floorNumber), flatLabel: editForm.flatLabel || undefined, payerType: editForm.payerType, paidByName: editForm.payerName || undefined, otherType: editForm.otherType || "Donation", otherTitle: editForm.otherTitle || undefined, otherNotes: editForm.otherNotes || undefined, receivedByUid: editForm.receivedByUid || undefined, receivedByName: residentNameByUid(editForm.receivedByUid, editForm.receivedByName), updatedAt: serverTimestamp() })); setShowEdit(false); }
// //     catch (e) { alert(e?.message || "Failed to update fund."); }
// //     finally { setSavingEdit(false); }
// //   };

// //   const residentFunds = funds.filter((fund) => (fund.sourceType || "resident") === "resident");
// //   const otherFunds = funds.filter((fund) => fund.sourceType === "other");
// //   const totalResidents = residentFunds.reduce((sum, fund) => sum + (Number(fund.amount) || 0), 0);
// //   const totalOther = otherFunds.reduce((sum, fund) => sum + (Number(fund.amount) || 0), 0);
// //   const sortedResidentFunds = [...residentFunds].sort((a, b) => cmpStr(a.blockName, b.blockName) || (extractFloor(a.flatLabel) ?? Infinity) - (extractFloor(b.flatLabel) ?? Infinity) || cmpStr(a.flatLabel, b.flatLabel));
// //   const sortedOtherFunds = [...otherFunds].sort((a, b) => cmpStr(a.otherType, b.otherType) || cmpStr(a.paidByName, b.paidByName));
// //   const paymentOptions = <><option value="">Select Pay Mode</option>{PAYMENT_METHODS.map((method) => <option key={method} value={method}>{method}</option>)}</>;
// //   const CollectorField = ({ form, setter }) => <Col md={3}><Form.Label>Received By</Form.Label><Form.Select value={collectorValue(form)} onChange={(e) => chooseCollector(e.target.value, setter)}><option value="">Select Committee Member</option>{committeeOptions.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}</Form.Select></Col>;

// //   return <div>
// //     {/* <div className="d-flex justify-content-between flex-wrap gap-2 mb-3"><h6>Funds Collection</h6><div className="d-flex gap-2"><Badge bg="secondary">Residents: ₹ {fmt(totalResidents)}</Badge><Badge bg="info">Other: ₹ {fmt(totalOther)}</Badge><Badge bg="success">Total: ₹ {fmt(totalResidents + totalOther)}</Badge></div></div> */}
// //    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
// //   <h6 className="mb-0">
// //     <strong>Funds Collection</strong>
// //   </h6>


// //   <div className="d-flex align-items-center gap-2 flex-wrap">
// //     <Badge bg="secondary p-2">
// //       Residents: ₹ {fmt(totalResidents)}
// //     </Badge>

// //     <Badge bg="info p-2">
// //       Other: ₹ {fmt(totalOther)}
// //     </Badge>

// //     <Badge bg="success p-2">
// //       Total: ₹{" "}
// //       {fmt(
// //         totalResidents + totalOther
// //       )}
// //     </Badge>

// //     {canEditFunds && (
// //   <Button
// //     type="button"
// //     size="sm"
// //     variant="primary"
// //     onClick={openAddFundsModal}
// //   >
// //     + Add Funds
// //   </Button>
// // )}

// //     {canEditFunds && (
// //       <Button
// //         type="button"
// //         size="sm"
// //         variant="danger"
// //         disabled={
// //           deleting ||
// //           !Array.isArray(
// //             selectedFunds
// //           ) ||
// //           selectedFunds.length === 0
// //         }
// //         onClick={
// //           handleDeleteSelected
// //         }
// //       >
// //         {deleting ? (
// //           <>
// //             <Spinner
// //               animation="border"
// //               size="sm"
// //               className="me-2"
// //             />
// //             Deleting...
// //           </>
// //         ) : (
// //           <>
// //             <i className="bi bi-trash me-1" />
// //             Delete Selected (
// //             {Array.isArray(selectedFunds)
// //               ? selectedFunds.length
// //               : 0}
// //             )
// //           </>
// //         )}
// //       </Button>
// //     )}
// //   </div>
// // </div>
   
// //     {/* {canEditFunds && <Nav variant="tabs" activeKey={innerTab} onSelect={(key) => key && setInnerTab(key)} className="mb-3"><Nav.Item><Nav.Link eventKey="resident">Residents</Nav.Link></Nav.Item><Nav.Item><Nav.Link eventKey="other">Other Funds</Nav.Link></Nav.Item></Nav>} */}


// //     {/* {innerTab === "resident" && canEditFunds && <Card className="mb-3"><Card.Body>
// //       <Row className="g-2"><Col md={3}><Form.Label>Block</Form.Label><Form.Select value={residentForm.blockName} onChange={(e) => setResidentForm((p) => ({ ...p, blockName: e.target.value, floorNumber: "", flatLabel: "" }))}><option value="">Select Block</option>{blockOptions.map((value) => <option key={value}>{value}</option>)}</Form.Select></Col><Col md={3}><Form.Label>Floor</Form.Label><Form.Select value={residentForm.floorNumber} disabled={!residentForm.blockName} onChange={(e) => setResidentForm((p) => ({ ...p, floorNumber: e.target.value, flatLabel: "" }))}><option value="">Select Floor</option>{residentFloorOptions.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}</Form.Select></Col><Col md={3}><Form.Label>Flat</Form.Label><Form.Select value={residentForm.flatLabel} disabled={residentForm.floorNumber === ""} onChange={(e) => setResidentForm((p) => ({ ...p, flatLabel: e.target.value }))}><option value="">Select Flat</option>{residentFlatOptions.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}</Form.Select></Col><Col md={3}><Form.Label>Amount</Form.Label><Form.Control type="number" value={residentForm.amount} disabled={residentForm.amountMode === "auto" && !isFamilyMode} onChange={(e) => setResidentForm((p) => ({ ...p, amount: e.target.value }))} /></Col><Col md={3}><Form.Label>Receipt No</Form.Label><Form.Control value={residentForm.receiptNo} onChange={(e) => setResidentForm((p) => ({ ...p, receiptNo: e.target.value }))} /></Col><Col md={3}><Form.Label>Pay Mode</Form.Label><Form.Select value={residentForm.method} onChange={(e) => setResidentForm((p) => ({ ...p, method: e.target.value }))}>{paymentOptions}</Form.Select></Col><CollectorField form={residentForm} setter={setResidentForm} /></Row>
// //       {householdLoading && <Spinner size="sm" className="mt-3" />}{householdMembers.length > 0 && <Button size="sm" variant="link" onClick={() => setShowFamilyTable((v) => !v)}>{showFamilyTable ? "Hide" : "Show"} family details</Button>}{showFamilyTable && <Table bordered size="sm"><tbody>{householdMembers.map((m, i) => <tr key={`${m.uid || m.id || m.name}-${i}`}><td>{m.name}</td><td>{m.age ?? "-"}</td><td>{m.relationship || "-"}</td></tr>)}</tbody></Table>}
// //       <div className="d-flex gap-2 flex-wrap mt-3"><Button onClick={addResidentFund}>Add Fund</Button><Button variant="outline-secondary" onClick={downloadResidentTemplate}>Download Resident Template</Button><Form.Label className={`btn btn-outline-success mb-0 ${uploading ? "disabled" : ""}`}>{uploading ? "Uploading..." : "Upload Resident Excel"}<Form.Control type="file" accept=".xlsx,.xls" hidden disabled={uploading} onChange={async (e) => { const file = e.target.files?.[0]; await handleResidentBulkUpload(file); e.target.value = ""; }} /></Form.Label><Button variant={receiptLinkCopied ? "success" : "outline-primary"} onClick={copyEventReceiptLink} disabled={copyingReceiptLink}>{receiptLinkCopied ? "Link Copied" : copyingReceiptLink ? "Copying..." : "Copy Receipt Link"}</Button></div>
// //     </Card.Body>
    
// //     </Card>} */}

// //     <Card.Header>
// //   <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
    
// //     <div>
// //       <strong>Current Event Receipts</strong>

// //       <Badge
// //         bg="primary"
// //         className="ms-2"
// //       >
// //         {funds.length}
// //       </Badge>
// //     </div>

// //     {canEditFunds && (
// //       <Button
// //         type="button"
// //         size="sm"
// //         variant="primary"
// //         onClick={openAddFundsModal}
// //       >
// //         + Add Funds
// //       </Button>
// //     )}

// //   </div>
// // </Card.Header>

// //     {/* {innerTab === "other" && canEditFunds && 
// //     <Card className="mb-3"><Card.Body><Row className="g-2">
// //       <Col md={3}><Form.Label>Payer Type</Form.Label><Form.Select value={otherForm.payerType} onChange={(e) => setOtherForm((p) => ({ ...initialOtherForm, type: p.type, payerType: e.target.value }))}><option value="resident">Resident</option><option value="other">Other / External</option></Form.Select></Col>
// //       <Col md={3}><Form.Label>Fund Type</Form.Label><Form.Select value={otherForm.type} onChange={(e) => setOtherForm((p) => ({ ...p, type: e.target.value }))}><option>Donation</option><option>Gift</option><option>Sale</option><option>Other</option></Form.Select></Col>
// //       <Col md={3}><Form.Label>Title</Form.Label><Form.Control value={otherForm.title} onChange={(e) => setOtherForm((p) => ({ ...p, title: e.target.value }))} /></Col>
// //       {otherForm.payerType === "resident" ? <><Col md={3}><Form.Label>Block</Form.Label><Form.Select value={otherForm.blockName} onChange={(e) => setOtherForm((p) => ({ ...p, blockName: e.target.value, floorNumber: "", flatLabel: "" }))}><option value="">Select Block</option>{blockOptions.map((value) => <option key={value}>{value}</option>)}</Form.Select></Col><Col md={3}><Form.Label>Floor</Form.Label><Form.Select value={otherForm.floorNumber} disabled={!otherForm.blockName} onChange={(e) => setOtherForm((p) => ({ ...p, floorNumber: e.target.value, flatLabel: "" }))}><option value="">Select Floor</option>{otherFloorOptions.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}</Form.Select></Col><Col md={3}><Form.Label>Flat</Form.Label><Form.Select value={otherForm.flatLabel} disabled={otherForm.floorNumber === ""} onChange={(e) => setOtherForm((p) => ({ ...p, flatLabel: e.target.value }))}><option value="">Select Flat</option>{otherFlatOptions.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}</Form.Select></Col></> : <Col md={3}><Form.Label>Payer / Donor</Form.Label><Form.Control value={otherForm.payerName} onChange={(e) => setOtherForm((p) => ({ ...p, payerName: e.target.value }))} /></Col>}
// //       <Col md={3}><Form.Label>Amount</Form.Label><Form.Control type="number" value={otherForm.amount} onChange={(e) => setOtherForm((p) => ({ ...p, amount: e.target.value }))} /></Col><Col md={3}><Form.Label>Receipt No</Form.Label><Form.Control value={otherForm.receiptNo} onChange={(e) => setOtherForm((p) => ({ ...p, receiptNo: e.target.value }))} /></Col><Col md={3}><Form.Label>Pay Mode</Form.Label><Form.Select value={otherForm.method} onChange={(e) => setOtherForm((p) => ({ ...p, method: e.target.value }))}>{paymentOptions}</Form.Select></Col><CollectorField form={otherForm} setter={setOtherForm} /><Col md={12}><Form.Label>Notes</Form.Label><Form.Control as="textarea" value={otherForm.notes} onChange={(e) => setOtherForm((p) => ({ ...p, notes: e.target.value }))} /></Col></Row><Button className="mt-3" onClick={addOtherFund}>Add Other Fund</Button></Card.Body></Card>} */}





// //     {error && <Alert variant="danger">{error}</Alert>}{loading ? <Spinner size="sm" /> : <><FundTable title="Resident Funds" funds={sortedResidentFunds} canEditFunds={canEditFunds} selectedFunds={selectedFunds} onSelectFund={handleSelectFund} onSelectAll={handleSelectAllFunds} onReceipt={(fund) => generateFundReceipt({ fund, community, event, residents })} onEdit={openEdit} onDelete={deleteFund} /><FundTable title="Other Funds" funds={sortedOtherFunds} canEditFunds={canEditFunds} selectedFunds={selectedFunds} onSelectFund={handleSelectFund} onSelectAll={handleSelectAllFunds} showPayerType onReceipt={(fund) => generateFundReceipt({ fund, community, event, residents })} onEdit={openEdit} onDelete={deleteFund} /></>}


// // <Modal
// //   show={showAddFunds}
// //   onHide={closeAddFundsModal}
// //   centered
// //   size="xl"
// //   backdrop="static"
// // >
// //   <Modal.Header closeButton={!uploading}>
// //     <Modal.Title>
// //       Add Funds
// //     </Modal.Title>
// //   </Modal.Header>

// //   <Modal.Body>
// //     <Nav
// //       variant="tabs"
// //       activeKey={innerTab}
// //       onSelect={(key) => {
// //         if (key) {
// //           setInnerTab(key);
// //         }
// //       }}
// //       className="mb-4"
// //     >
// //       <Nav.Item>
// //         <Nav.Link eventKey="resident">
// //           Resident Fund
// //         </Nav.Link>
// //       </Nav.Item>

// //       <Nav.Item>
// //         <Nav.Link eventKey="other">
// //           Other Fund
// //         </Nav.Link>
// //       </Nav.Item>
// //     </Nav>

// //     {innerTab === "resident" && (
// //       <ResidentFundForm
// //         residentForm={residentForm}
// //         setResidentForm={setResidentForm}
// //         blockOptions={blockOptions}
// //         floorOptions={residentFloorOptions}
// //         flatOptions={residentFlatOptions}
// //         paymentOptions={paymentOptions}
// //         CollectorField={CollectorField}
// //         householdLoading={householdLoading}
// //         householdMembers={householdMembers}
// //         showFamilyTable={showFamilyTable}
// //         setShowFamilyTable={setShowFamilyTable}
// //         uploading={uploading}
// //         addResidentFund={addResidentFund}
// //         downloadResidentTemplate={downloadResidentTemplate}
// //         handleResidentBulkUpload={handleResidentBulkUpload}
// //         copyEventReceiptLink={copyEventReceiptLink}
// //         copyingReceiptLink={copyingReceiptLink}
// //         receiptLinkCopied={receiptLinkCopied}
// //         isFamilyMode={isFamilyMode}
// //       />
// //     )}

// //     {innerTab === "other" && (
// //      <OtherFundForm
// //   otherForm={otherForm}
// //   setOtherForm={setOtherForm}
// //   blockOptions={blockOptions}
// //   floorOptions={otherFloorOptions}
// //   flatOptions={otherFlatOptions}
// //   paymentOptions={paymentOptions}
// //   CollectorField={CollectorField}
// //   addOtherFund={addOtherFund}
// //   selectedFlatResidents={selectedFlatResidents}
// //   fundDetailLabel={otherFundDetailLabel}
// // />
// //     )}
// //   </Modal.Body>

// //   <Modal.Footer>
// //     <Button
// //       type="button"
// //       variant="secondary"
// //       disabled={uploading}
// //       onClick={closeAddFundsModal}
// //     >
// //       Close
// //     </Button>
// //     </Modal.Footer>
// //   </Modal>

// //     <Modal show={showEdit} onHide={() => setShowEdit(false)} centered><Modal.Header closeButton><Modal.Title>Edit Fund</Modal.Title></Modal.Header>
// //     <Modal.Body>
// //       <Form.Label>Amount</Form.Label>
// //       <Form.Control type="number" value={editForm.amount} onChange={(e) => setEditForm((p) => ({ ...p, amount: e.target.value }))} />
// //              <Form.Label className="mt-2">
// //   Fund Type
// // </Form.Label>

// // <Form.Select
// //   value={editForm.otherType || "Donation"}
// //   onChange={(e) =>
// //     setEditForm((p) => ({
// //       ...p,
// //       otherType: e.target.value,
// //     }))
// //   }
// // >
// //   <option value="Donation">Donation</option>
// //   <option value="Sponsor">Sponsor</option>
// //   <option value="Gift">Gift</option>
// //   <option value="Sale">Sale</option>
// //   <option value="Other">Other</option>
// // </Form.Select>
// //         <Form.Label className="mt-2">Receipt No</Form.Label>
// //         <Form.Control value={editForm.receiptNo} onChange={(e) => setEditForm((p) => ({ ...p, receiptNo: e.target.value }))} />
// //           <Form.Label className="mt-2">Pay Mode</Form.Label>
// //           <Form.Select value={editForm.method} onChange={(e) => setEditForm((p) => ({ ...p, method: e.target.value }))}>{paymentOptions}</Form.Select>
// //           </Modal.Body><Modal.Footer><Button variant="secondary" onClick={() => setShowEdit(false)}>Cancel</Button><Button onClick={saveEdit} disabled={savingEdit}>{savingEdit ? "Saving..." : "Save Changes"}</Button></Modal.Footer></Modal>

          
// //   </div>;
// // }

// // function ResidentFundForm({
// //   residentForm,
// //   setResidentForm,
// //   blockOptions,
// //   floorOptions,
// //   flatOptions,
// //   paymentOptions,
// //   CollectorField,
// //   householdLoading,
// //   householdMembers,
// //   showFamilyTable,
// //   setShowFamilyTable,
// //   uploading,
// //   addResidentFund,
// //   downloadResidentTemplate,
// //   handleResidentBulkUpload,
// //   copyEventReceiptLink,
// //   copyingReceiptLink,
// //   receiptLinkCopied,
// //   isFamilyMode,
// // }) {
// //   return (
// //     <div>
// //       <Row className="g-3">
// //         <Col md={3}>
// //           <Form.Label>Block</Form.Label>

// //           <Form.Select
// //             value={residentForm.blockName}
// //             onChange={(eventValue) =>
// //               setResidentForm((previous) => ({
// //                 ...previous,
// //                 blockName: eventValue.target.value,
// //                 floorNumber: "",
// //                 flatLabel: "",
// //               }))
// //             }
// //           >
// //             <option value="">
// //               Select Block
// //             </option>

// //             {blockOptions.map((value) => (
// //               <option
// //                 key={value}
// //                 value={value}
// //               >
// //                 {value}
// //               </option>
// //             ))}
// //           </Form.Select>
// //         </Col>

// //         <Col md={3}>
// //           <Form.Label>Floor</Form.Label>

// //           <Form.Select
// //             value={residentForm.floorNumber}
// //             disabled={!residentForm.blockName}
// //             onChange={(eventValue) =>
// //               setResidentForm((previous) => ({
// //                 ...previous,
// //                 floorNumber: eventValue.target.value,
// //                 flatLabel: "",
// //               }))
// //             }
// //           >
// //             <option value="">
// //               Select Floor
// //             </option>

// //             {floorOptions.map((option) => (
// //               <option
// //                 key={option.value}
// //                 value={option.value}
// //               >
// //                 {option.label}
// //               </option>
// //             ))}
// //           </Form.Select>
// //         </Col>

// //         <Col md={3}>
// //           <Form.Label>Flat</Form.Label>

// //           <Form.Select
// //             value={residentForm.flatLabel}
// //             disabled={residentForm.floorNumber === ""}
// //             onChange={(eventValue) =>
// //               setResidentForm((previous) => ({
// //                 ...previous,
// //                 flatLabel: eventValue.target.value,
// //               }))
// //             }
// //           >
// //             <option value="">
// //               Select Flat
// //             </option>

// //             {flatOptions.map((option) => (
// //               <option
// //                 key={option.value}
// //                 value={option.value}
// //               >
// //                 {option.label}
// //               </option>
// //             ))}
// //           </Form.Select>
// //         </Col>

// //         <Col md={3}>
// //           <Form.Label>Amount</Form.Label>

// //           <Form.Control
// //             type="number"
// //             min="0"
// //             step="0.01"
// //             value={residentForm.amount}
// //             disabled={
// //               residentForm.amountMode === "auto" &&
// //               !isFamilyMode
// //             }
// //             onChange={(eventValue) =>
// //               setResidentForm((previous) => ({
// //                 ...previous,
// //                 amount: eventValue.target.value,
// //               }))
// //             }
// //           />
// //         </Col>

// //         <Col md={3}>
// //           <Form.Label>Receipt No</Form.Label>

// //           <Form.Control
// //             value={residentForm.receiptNo}
// //             onChange={(eventValue) =>
// //               setResidentForm((previous) => ({
// //                 ...previous,
// //                 receiptNo: eventValue.target.value,
// //               }))
// //             }
// //           />
// //         </Col>

// //         <Col md={3}>
// //           <Form.Label>Pay Mode</Form.Label>

// //           <Form.Select
// //             value={residentForm.method}
// //             onChange={(eventValue) =>
// //               setResidentForm((previous) => ({
// //                 ...previous,
// //                 method: eventValue.target.value,
// //               }))
// //             }
// //           >
// //             {paymentOptions}
// //           </Form.Select>
// //         </Col>

// //         <CollectorField
// //           form={residentForm}
// //           setter={setResidentForm}
// //         />
// //       </Row>

// //       {householdLoading && (
// //         <div className="mt-3">
// //           <Spinner
// //             animation="border"
// //             size="sm"
// //             className="me-2"
// //           />
// //           Loading family details...
// //         </div>
// //       )}

// //       {householdMembers.length > 0 && (
// //         <Button
// //           type="button"
// //           size="sm"
// //           variant="link"
// //           className="px-0 mt-2"
// //           onClick={() =>
// //             setShowFamilyTable((previous) => !previous)
// //           }
// //         >
// //           {showFamilyTable ? "Hide" : "Show"} family details
// //         </Button>
// //       )}

// //       {showFamilyTable &&
// //         householdMembers.length > 0 && (
// //           <Table
// //             bordered
// //             responsive
// //             size="sm"
// //             className="mt-2"
// //           >
// //             <thead>
// //               <tr>
// //                 <th>Name</th>
// //                 <th>Age</th>
// //                 <th>Relationship</th>
// //               </tr>
// //             </thead>

// //             <tbody>
// //               {householdMembers.map((member, index) => (
// //                 <tr
// //                   key={`family-${member.uid || member.id || member.name}-${index}`}
// //                 >
// //                   <td>{member.name}</td>
// //                   <td>{member.age ?? "-"}</td>
// //                   <td>
// //                     {member.relationship || "-"}
// //                   </td>
// //                 </tr>
// //               ))}
// //             </tbody>
// //           </Table>
// //         )}

// //       <div className="d-flex gap-2 flex-wrap mt-4">
// //         <Button
// //           type="button"
// //           variant="primary"
// //           onClick={addResidentFund}
// //         >
// //           Add Resident Fund
// //         </Button>

// //         <Button
// //           type="button"
// //           variant="outline-secondary"
// //           onClick={downloadResidentTemplate}
// //         >
// //           Download Resident Template
// //         </Button>

// //         <Form.Label
// //           className={`btn btn-outline-success mb-0 ${
// //             uploading ? "disabled" : ""
// //           }`}
// //         >
// //           {uploading
// //             ? "Uploading..."
// //             : "Upload Resident Excel"}

// //           <Form.Control
// //             type="file"
// //             accept=".xlsx,.xls"
// //             hidden
// //             disabled={uploading}
// //             onChange={async (eventValue) => {
// //               const file =
// //                 eventValue.target.files?.[0];

// //               try {
// //                 await handleResidentBulkUpload(file);
// //               } finally {
// //                 eventValue.target.value = "";
// //               }
// //             }}
// //           />
// //         </Form.Label>

// //         <Button
// //           type="button"
// //           variant={
// //             receiptLinkCopied
// //               ? "success"
// //               : "outline-primary"
// //           }
// //           disabled={copyingReceiptLink}
// //           onClick={copyEventReceiptLink}
// //         >
// //           {copyingReceiptLink
// //             ? "Copying..."
// //             : receiptLinkCopied
// //               ? "Link Copied"
// //               : "Copy Receipt Link"}
// //         </Button>
// //       </div>
// //     </div>
// //   );
// // }


// // // function OtherFundForm({
// // //   otherForm,
// // //   setOtherForm,
// // //   blockOptions,
// // //   floorOptions,
// // //   flatOptions,
// // //   paymentOptions,
// // //   CollectorField,
// // //   addOtherFund,
// // // }) {
// // //   return (
// // //     <div>
// // //       <Row className="g-3">
// // //         <Col md={3}>
// // //           <Form.Label>Payer Type</Form.Label>

// // //           <Form.Select
// // //             value={otherForm.payerType}
// // //             onChange={(eventValue) =>
// // //               setOtherForm((previous) => ({
// // //                 ...initialOtherForm,
// // //                 type: previous.type,
// // //                 payerType: eventValue.target.value,
// // //               }))
// // //             }
// // //           >
// // //             <option value="resident">
// // //               Resident
// // //             </option>

// // //             <option value="other">
// // //               Other / External
// // //             </option>
// // //           </Form.Select>
// // //         </Col>

// // //         <Col md={3}>
// // //           <Form.Label>Fund Type</Form.Label>

// // //           <Form.Select
// // //             value={otherForm.type}
// // //             onChange={(eventValue) =>
// // //               setOtherForm((previous) => ({
// // //                 ...previous,
// // //                 type: eventValue.target.value,
// // //               }))
// // //             }
// // //           >
// // //             <option value="Donation">
// // //               Donation
// // //             </option>

// // //             <option value="Sponsor">
// // //               Sponsor
// // //             </option>

// // //             <option value="Gift">
// // //               Gift
// // //             </option>

// // //             <option value="Sale">
// // //               Sale
// // //             </option>

// // //             <option value="Other">
// // //               Other
// // //             </option>
// // //           </Form.Select>
// // //         </Col>

// // //         <Col md={3}>
// // //           <Form.Label>Title</Form.Label>

// // //           <Form.Control
// // //             value={otherForm.title}
// // //             placeholder="Enter title"
// // //             onChange={(eventValue) =>
// // //               setOtherForm((previous) => ({
// // //                 ...previous,
// // //                 title: eventValue.target.value,
// // //               }))
// // //             }
// // //           />
// // //         </Col>

// // //         {otherForm.payerType === "resident" ? (
// // //           <>
// // //             <Col md={3}>
// // //               <Form.Label>Block</Form.Label>

// // //               <Form.Select
// // //                 value={otherForm.blockName}
// // //                 onChange={(eventValue) =>
// // //                   setOtherForm((previous) => ({
// // //                     ...previous,
// // //                     blockName: eventValue.target.value,
// // //                     floorNumber: "",
// // //                     flatLabel: "",
// // //                   }))
// // //                 }
// // //               >
// // //                 <option value="">
// // //                   Select Block
// // //                 </option>

// // //                 {blockOptions.map((value) => (
// // //                   <option
// // //                     key={value}
// // //                     value={value}
// // //                   >
// // //                     {value}
// // //                   </option>
// // //                 ))}
// // //               </Form.Select>
// // //             </Col>

// // //             <Col md={3}>
// // //               <Form.Label>Floor</Form.Label>

// // //               <Form.Select
// // //                 value={otherForm.floorNumber}
// // //                 disabled={!otherForm.blockName}
// // //                 onChange={(eventValue) =>
// // //                   setOtherForm((previous) => ({
// // //                     ...previous,
// // //                     floorNumber: eventValue.target.value,
// // //                     flatLabel: "",
// // //                   }))
// // //                 }
// // //               >
// // //                 <option value="">
// // //                   Select Floor
// // //                 </option>

// // //                 {floorOptions.map((option) => (
// // //                   <option
// // //                     key={option.value}
// // //                     value={option.value}
// // //                   >
// // //                     {option.label}
// // //                   </option>
// // //                 ))}
// // //               </Form.Select>
// // //             </Col>

// // //             <Col md={3}>
// // //               <Form.Label>Flat</Form.Label>

// // //               <Form.Select
// // //                 value={otherForm.flatLabel}
// // //                 disabled={otherForm.floorNumber === ""}
// // //                 onChange={(eventValue) =>
// // //                   setOtherForm((previous) => ({
// // //                     ...previous,
// // //                     flatLabel: eventValue.target.value,
// // //                   }))
// // //                 }
// // //               >
// // //                 <option value="">
// // //                   Select Flat
// // //                 </option>

// // //                 {flatOptions.map((option) => (
// // //                   <option
// // //                     key={option.value}
// // //                     value={option.value}
// // //                   >
// // //                     {option.label}
// // //                   </option>
// // //                 ))}
// // //               </Form.Select>
// // //             </Col>
// // //           </>
// // //         ) : (
// // //           <Col md={3}>
// // //             <Form.Label>
// // //               Payer / Donor
// // //             </Form.Label>

// // //             <Form.Control
// // //               value={otherForm.payerName}
// // //               placeholder="Enter payer name"
// // //               onChange={(eventValue) =>
// // //                 setOtherForm((previous) => ({
// // //                   ...previous,
// // //                   payerName: eventValue.target.value,
// // //                 }))
// // //               }
// // //             />
// // //           </Col>
// // //         )}

// // //         <Col md={3}>
// // //           <Form.Label>Amount</Form.Label>

// // //           <Form.Control
// // //             type="number"
// // //             min="0"
// // //             step="0.01"
// // //             value={otherForm.amount}
// // //             onChange={(eventValue) =>
// // //               setOtherForm((previous) => ({
// // //                 ...previous,
// // //                 amount: eventValue.target.value,
// // //               }))
// // //             }
// // //           />
// // //         </Col>

// // //         <Col md={3}>
// // //           <Form.Label>Receipt No</Form.Label>

// // //           <Form.Control
// // //             value={otherForm.receiptNo}
// // //             onChange={(eventValue) =>
// // //               setOtherForm((previous) => ({
// // //                 ...previous,
// // //                 receiptNo: eventValue.target.value,
// // //               }))
// // //             }
// // //           />
// // //         </Col>

// // //         <Col md={3}>
// // //           <Form.Label>Pay Mode</Form.Label>

// // //           <Form.Select
// // //             value={otherForm.method}
// // //             onChange={(eventValue) =>
// // //               setOtherForm((previous) => ({
// // //                 ...previous,
// // //                 method: eventValue.target.value,
// // //               }))
// // //             }
// // //           >
// // //             {paymentOptions}
// // //           </Form.Select>
// // //         </Col>

// // //         <CollectorField
// // //           form={otherForm}
// // //           setter={setOtherForm}
// // //         />

// // //         <Col md={12}>
// // //           <Form.Label>Notes</Form.Label>

// // //           <Form.Control
// // //             as="textarea"
// // //             rows={3}
// // //             value={otherForm.notes}
// // //             onChange={(eventValue) =>
// // //               setOtherForm((previous) => ({
// // //                 ...previous,
// // //                 notes: eventValue.target.value,
// // //               }))
// // //             }
// // //           />
// // //         </Col>
// // //       </Row>

// // //       <Button
// // //         type="button"
// // //         className="mt-4"
// // //         variant="primary"
// // //         onClick={addOtherFund}
// // //       >
// // //         Add Other Fund
// // //       </Button>
// // //     </div>
// // //   );
// // // }


// // function OtherFundForm({
// //   otherForm,
// //   setOtherForm,
// //   blockOptions = [],
// //   floorOptions = [],
// //   flatOptions = [],
// //   paymentOptions,
// //   CollectorField,
// //   addOtherFund,
// //   selectedFlatResidents = [],
// //   fundDetailLabel = "Fund Purpose",
// // }) {
// //   const isResidentPayer =
// //     otherForm.payerType === "resident";

// //   const isOtherResident =
// //     otherForm.residentSelection === "other";

// //   const safeFundDetailLabel =
// //     String(fundDetailLabel || "").trim() ||
// //     "Fund Purpose";

// //   const handlePayerTypeChange = (event) => {
// //     const payerType = event.target.value;

// //     setOtherForm((previous) => ({
// //       ...initialOtherForm,
// //       payerType,
// //       type: previous.type || "Donation",
// //       title: previous.title || "",
// //     }));
// //   };

// //   const handleFundTypeChange = (event) => {
// //     const type = event.target.value;

// //     setOtherForm((previous) => ({
// //       ...previous,
// //       type,
// //       title: "",
// //     }));
// //   };

// //   // const handleResidentSelectionChange = (event) => {
// //   //   const selectedValue = event.target.value;

// //   //   if (!selectedValue) {
// //   //     setOtherForm((previous) => ({
// //   //       ...previous,
// //   //       residentSelection: "",
// //   //       payerUid: "",
// //   //       payerName: "",
// //   //     }));

// //   //     return;
// //   //   }

// //   //   if (selectedValue === "other") {
// //   //     setOtherForm((previous) => ({
// //   //       ...previous,
// //   //       residentSelection: "other",
// //   //       payerUid: "",
// //   //       payerName: "",
// //   //     }));

// //   //     return;
// //   //   }

// //   //   const selectedResident =
// //   //     selectedFlatResidents.find(
// //   //       (resident) =>
// //   //         resident.value === selectedValue
// //   //     );

// //   //   setOtherForm((previous) => ({
// //   //     ...previous,
// //   //     residentSelection: selectedValue,
// //   //     payerUid: selectedResident?.uid || "",
// //   //     payerName: selectedResident?.name || "",
// //   //   }));
// //   // };

// //   const handleResidentSelectionChange = (event) => {
// //   const selectedValue = event.target.value;

// //   if (!selectedValue) {
// //     setOtherForm((previous) => ({
// //       ...previous,
// //       residentSelection: "",
// //       payerUid: "",
// //       payerName: "",
// //     }));

// //     return;
// //   }

// //   if (selectedValue === "other") {
// //     setOtherForm((previous) => ({
// //       ...previous,
// //       residentSelection: "other",
// //       payerUid: "",
// //       payerName: "",
// //     }));

// //     return;
// //   }

// //   const selectedResident =
// //     selectedFlatResidents.find(
// //       (resident) =>
// //         resident.value === selectedValue
// //     );

// //   if (!selectedResident) {
// //     setOtherForm((previous) => ({
// //       ...previous,
// //       residentSelection: "",
// //       payerUid: "",
// //       payerName: "",
// //     }));

// //     return;
// //   }

// //   setOtherForm((previous) => ({
// //     ...previous,
// //     residentSelection: selectedResident.value,
// //     payerUid: selectedResident.uid || "",
// //     payerName: selectedResident.name || "",
// //   }));
// // };



// //   const getFundPurposeHelpText = () => {
// //     switch (otherForm.type) {
// //       case "Donation":
// //         return "Example: Festival decoration donation";

// //       case "Sponsor":
// //         return "Example: ABC Company stage sponsorship";

// //       case "Gift":
// //         return "Example: Gift items for event winners";

// //       case "Sale":
// //         return "Example: Food stall or ticket sale";

// //       case "Other":
// //         return "Enter the purpose or description of this fund";

// //       default:
// //         return "";
// //     }
// //   };

// //   return (
// //     <div>
// //       <Row className="g-3">
// //         <Col md={3}>
// //           <Form.Label>Payer Type</Form.Label>

// //           <Form.Select
// //             value={otherForm.payerType}
// //             onChange={handlePayerTypeChange}
// //           >
// //             <option value="resident">
// //               Resident
// //             </option>

// //             <option value="other">
// //               Other / External
// //             </option>
// //           </Form.Select>
// //         </Col>

// //         <Col md={3}>
// //           <Form.Label>Fund Type</Form.Label>

// //           <Form.Select
// //             value={otherForm.type}
// //             onChange={handleFundTypeChange}
// //           >
// //             <option value="Donation">
// //               Donation
// //             </option>

// //             <option value="Sponsor">
// //               Sponsor
// //             </option>

// //             <option value="Gift">
// //               Gift
// //             </option>

// //             <option value="Sale">
// //               Sale
// //             </option>

// //             <option value="Other">
// //               Other
// //             </option>
// //           </Form.Select>
// //         </Col>

// //         <Col md={6}>
// //           <Form.Label>
// //             {safeFundDetailLabel}
// //           </Form.Label>

// //           <Form.Control
// //             type="text"
// //             value={otherForm.title}
// //             placeholder={`Enter ${safeFundDetailLabel.toLowerCase()}`}
// //             onChange={(event) =>
// //               setOtherForm((previous) => ({
// //                 ...previous,
// //                 title: event.target.value,
// //               }))
// //             }
// //           />

// //           <Form.Text className="text-muted">
// //             {getFundPurposeHelpText()}
// //           </Form.Text>
// //         </Col>

// //         {isResidentPayer ? (
// //           <>
// //             <Col md={3}>
// //               <Form.Label>Block</Form.Label>

// //               <Form.Select
// //                 value={otherForm.blockName}
// //                 onChange={(event) =>
// //                   setOtherForm((previous) => ({
// //                     ...previous,
// //                     blockName: event.target.value,
// //                     floorNumber: "",
// //                     flatLabel: "",
// //                     residentSelection: "",
// //                     payerUid: "",
// //                     payerName: "",
// //                   }))
// //                 }
// //               >
// //                 <option value="">
// //                   Select Block
// //                 </option>

// //                 {blockOptions.map((blockName) => (
// //                   <option
// //                     key={blockName}
// //                     value={blockName}
// //                   >
// //                     {blockName}
// //                   </option>
// //                 ))}
// //               </Form.Select>
// //             </Col>

// //             <Col md={3}>
// //               <Form.Label>Floor</Form.Label>

// //               <Form.Select
// //                 value={otherForm.floorNumber}
// //                 disabled={!otherForm.blockName}
// //                 onChange={(event) =>
// //                   setOtherForm((previous) => ({
// //                     ...previous,
// //                     floorNumber: event.target.value,
// //                     flatLabel: "",
// //                     residentSelection: "",
// //                     payerUid: "",
// //                     payerName: "",
// //                   }))
// //                 }
// //               >
// //                 <option value="">
// //                   Select Floor
// //                 </option>

// //                 {floorOptions.map((option) => (
// //                   <option
// //                     key={option.value}
// //                     value={option.value}
// //                   >
// //                     {option.label}
// //                   </option>
// //                 ))}
// //               </Form.Select>
// //             </Col>

// //             <Col md={3}>
// //               <Form.Label>Flat</Form.Label>

// //               <Form.Select
// //                 value={otherForm.flatLabel}
// //                 disabled={
// //                   otherForm.floorNumber === ""
// //                 }
// //                 onChange={(event) =>
// //                   setOtherForm((previous) => ({
// //                     ...previous,
// //                     flatLabel: event.target.value,
// //                     residentSelection: "",
// //                     payerUid: "",
// //                     payerName: "",
// //                   }))
// //                 }
// //               >
// //                 <option value="">
// //                   Select Flat
// //                 </option>

// //                 {flatOptions.map((option) => (
// //                   <option
// //                     key={option.value}
// //                     value={option.value}
// //                   >
// //                     {option.label}
// //                   </option>
// //                 ))}
// //               </Form.Select>
// //             </Col>

// //           <Col md={3}>
// //   <Form.Label>Resident Name</Form.Label>

// //   <Form.Select
// //     value={otherForm.residentSelection || ""}
// //     disabled={!otherForm.flatLabel}
// //     onChange={handleResidentSelectionChange}
// //   >
// //     <option value="">
// //       {otherForm.flatLabel
// //         ? "Select Resident"
// //         : "Select Flat First"}
// //     </option>

// //     {selectedFlatResidents.map((resident) => (
// //       <option
// //         key={resident.value}
// //         value={resident.value}
// //       >
// //         {resident.name}
// //       </option>
// //     ))}

// //     <option value="other">Other Name</option>
// //   </Form.Select>

// //   {otherForm.flatLabel &&
// //     selectedFlatResidents.length === 0 && (
// //       <Form.Text className="text-muted">
// //         No registered resident was found for this
// //         flat. Select Other Name to enter the name
// //         manually.
// //       </Form.Text>
// //     )}

// //   {otherForm.residentSelection &&
// //     otherForm.residentSelection !== "other" &&
// //     otherForm.payerName && (
// //       <Form.Text className="text-success">
// //         Selected resident: {otherForm.payerName}
// //       </Form.Text>
// //     )}
// // </Col>

// //            {isOtherResident && (
// //   <Col md={3}>
// //     <Form.Label>Enter Resident Name</Form.Label>

// //     <Form.Control
// //       type="text"
// //       value={otherForm.payerName}
// //       placeholder="Enter resident name"
// //       onChange={(event) =>
// //         setOtherForm((previous) => ({
// //           ...previous,
// //           payerName: event.target.value,
// //           payerUid: "",
// //         }))
// //       }
// //     />
// //   </Col>
// // )}
// //           </>
// //         ) : (
// //           <Col md={3}>
// //             <Form.Label>
// //               Payer / Donor / Sponsor Name
// //             </Form.Label>

// //             <Form.Control
// //               type="text"
// //               value={otherForm.payerName}
// //               placeholder="Enter payer name"
// //               onChange={(event) =>
// //                 setOtherForm((previous) => ({
// //                   ...previous,
// //                   payerName: event.target.value,
// //                   payerUid: "",
// //                 }))
// //               }
// //             />
// //           </Col>
// //         )}

// //         <Col md={3}>
// //           <Form.Label>Amount</Form.Label>

// //           <Form.Control
// //             type="number"
// //             min="0"
// //             step="0.01"
// //             value={otherForm.amount}
// //             placeholder="Enter amount"
// //             onChange={(event) =>
// //               setOtherForm((previous) => ({
// //                 ...previous,
// //                 amount: event.target.value,
// //               }))
// //             }
// //           />
// //         </Col>

// //         <Col md={3}>
// //           <Form.Label>Receipt No</Form.Label>

// //           <Form.Control
// //             type="text"
// //             value={otherForm.receiptNo}
// //             placeholder="Enter receipt number"
// //             onChange={(event) =>
// //               setOtherForm((previous) => ({
// //                 ...previous,
// //                 receiptNo: event.target.value,
// //               }))
// //             }
// //           />
// //         </Col>

// //         <Col md={3}>
// //           <Form.Label>Pay Mode</Form.Label>

// //           <Form.Select
// //             value={otherForm.method}
// //             onChange={(event) =>
// //               setOtherForm((previous) => ({
// //                 ...previous,
// //                 method: event.target.value,
// //               }))
// //             }
// //           >
// //             {paymentOptions}
// //           </Form.Select>
// //         </Col>

// //         <CollectorField
// //           form={otherForm}
// //           setter={setOtherForm}
// //         />

// //         <Col md={12}>
// //           <Form.Label>
// //             Additional Notes
// //           </Form.Label>

// //           <Form.Control
// //             as="textarea"
// //             rows={3}
// //             value={otherForm.notes}
// //             placeholder="Enter additional notes"
// //             onChange={(event) =>
// //               setOtherForm((previous) => ({
// //                 ...previous,
// //                 notes: event.target.value,
// //               }))
// //             }
// //           />
// //         </Col>
// //       </Row>

// //       <div className="d-flex justify-content-end mt-4">
// //         <Button
// //           type="button"
// //           variant="primary"
// //           onClick={addOtherFund}
// //         >
// //           Add {otherForm.type || "Other"} Fund
// //         </Button>
// //       </div>
// //     </div>
// //   );
// // }

// // function FundTable({ title, funds, canEditFunds, selectedFunds = [], onSelectFund, onSelectAll, showPayerType = false, onReceipt, onEdit, onDelete }) {
// //   return <Card className="mb-3"><Card.Header><strong>{title}</strong></Card.Header><Card.Body className="p-0"><Table bordered hover responsive size="sm" className="mb-0"><thead><tr> 
// //     {canEditFunds && (
// //     <th style={{ width: "60px" }}>
// //       <Form.Check
// //         type="checkbox"
// //         checked={
// //           funds.length > 0 &&
// //           funds.every((fund) =>
// //             selectedFunds.includes(
// //               fund.id
// //             )
// //           )
// //         }
// //         onChange={() =>
// //           onSelectAll?.(funds)
// //         }
// //       />
// //     </th>
// //   )} 
// //      {showPayerType && <th>Payer Type</th>} 
  
// //    <th>Block</th><th>Flat</th><th style={{ whiteSpace: "nowrap", width: "150px" }} >Payer</th><th>Amount</th><th>Receipt</th><th>Method</th><th style={{ whiteSpace: "nowrap", width: "120px" }}>Received By</th>
// //   {/* <th>Created</th> */}
// //   <th>PDF</th>{canEditFunds && <th>Actions</th>}</tr></thead><tbody>{funds.length === 0 ? <tr><td colSpan={canEditFunds ? showPayerType ? 13 : 12 : showPayerType ? 11 : 10} className="text-center">No funds yet</td></tr> : funds.map((fund) => <tr key={fund.id}>
// //      {canEditFunds && (
// //     <td>
// //       <Form.Check
// //         type="checkbox"
// //         checked={(selectedFunds || []).includes(fund.id)}
// //         onChange={() =>
// //           onSelectFund?.(fund.id)
// //         }
// //       />
// //     </td>
// //   )} 
// //     {showPayerType && <td>{fund.payerType === "resident" ? "Resident" : "Other"}</td>} 
 
// //   <td>{fund.blockName || "-"}</td><td style={{ whiteSpace: "nowrap", width: "50px" }}>{fund.flatLabel || "-"}</td><td>{fund.paidByName || "-"}</td><td style={{ whiteSpace: "nowrap", width: "120px" }}>
// //   ₹ {fmt(fund.amount)}
// // </td><td>{fund.receiptNo || "-"}</td><td>{fund.method || "-"}</td><td>{fund.receivedByName || "-"}</td>
// // {/* <td>{fmtTs(fund.createdAt)}</td> */}
// // <td><Button size="sm" variant="outline-primary" onClick={() => onReceipt(fund)}>Receipt</Button></td>{canEditFunds && <td style={{ whiteSpace: "nowrap", width: "120px" }}><Button size="sm" variant="outline-secondary" onClick={() => onEdit(fund)}>Edit</Button>{" "}<Button size="sm" variant="outline-danger" onClick={() => onDelete(fund.id)}>Delete</Button></td>}</tr>)}</tbody></Table></Card.Body></Card>;
// // }


// import React, { useCallback, useEffect, useMemo, useState } from "react";
// import { Alert, Badge, Button, Card, Form, Modal, Nav, Spinner, Table } from "react-bootstrap";
// import { collection, deleteDoc, doc, onSnapshot, orderBy, query, updateDoc, serverTimestamp, writeBatch } from "firebase/firestore";
// import { db } from "../../firebase";
// import { cleanObject, fmt } from "../../utils/eventUtils";
// import { generateFundReceipt } from "../../utils/generateFundReceipt";
// import FundContribution from "./FundContribution";
// import FundDonation from "./FundDonation";
// import * as XLSX from "xlsx";



// const PAYMENT_METHODS = ["Cash", "PhonePe", "Google Pay", "UPI", "Bank Transfer"];
// const cmpStr = (a, b) => String(a || "").localeCompare(String(b || ""), undefined, { sensitivity: "base" });

// export default function FundsPanel({ communityId, event, community, residents = [], canEditFunds }) {
//   const eventId = event?.id;
//   const [funds, setFunds] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [showAdd, setShowAdd] = useState(false);
//   const [activeTab, setActiveTab] = useState("contribution");
//   const [selectedFunds, setSelectedFunds] = useState([]);
//   const [deleting, setDeleting] = useState(false);
//   const [editFund, setEditFund] = useState(null);
//   const [editForm, setEditForm] = useState({ amount: "", receiptNo: "", method: "", paidByName: "", receivedByName: "", otherType: "Donation", otherTitle: "" });
//   const [savingEdit, setSavingEdit] = useState(false);

//   useEffect(() => {
//     if (!eventId) { setError("Missing event ID."); setLoading(false); return undefined; }
//     setLoading(true);
//     return onSnapshot(query(collection(db, "events", eventId, "funds"), orderBy("createdAt", "desc")), (snapshot) => {
//       setFunds(snapshot.docs.map((item) => ({ id: item.id, ...item.data() })));
//       setError("");
//       setLoading(false);
//     }, (snapshotError) => { setError(snapshotError?.message || "Failed to load funds."); setLoading(false); });
//   }, [eventId]);

//   useEffect(() => setSelectedFunds((previous) => previous.filter((id) => funds.some((fund) => fund.id === id))), [funds]);

//   const residentNameByUid = useCallback((uid, fallback = "") => {
//     const resident = residents.find((item) => String(item?.uid || item?.id || "") === String(uid || ""));
//     return resident?.fullName || resident?.displayName || resident?.name || fallback || uid || "";
//   }, [residents]);

//   const committeeOptions = useMemo(() => {
//     const values = new Map();
//     (Array.isArray(event?.committee) ? event.committee : []).forEach((member) => {
//       const uid = String(member?.uid || "").trim();
//       const suppliedName = String(member?.residentName || member?.name || member?.fullName || member?.displayName || "").trim();
//       const label = uid ? residentNameByUid(uid, suppliedName) : suppliedName;
//       const value = uid ? `uid:${uid}` : label ? `name:${label}` : "";
//       if (value && !values.has(value)) values.set(value, { value, uid, label });
//     });
//     return [...values.values()].sort((a, b) => cmpStr(a.label, b.label));
//   }, [event?.committee, residentNameByUid]);

//   const residentFunds = useMemo(() => funds.filter((fund) => (fund.sourceType || "resident") === "resident").sort((a, b) => cmpStr(a.blockName, b.blockName) || cmpStr(a.flatLabel, b.flatLabel)), [funds]);
//   const otherFunds = useMemo(() => funds.filter((fund) => fund.sourceType === "other").sort((a, b) => cmpStr(a.otherType, b.otherType) || cmpStr(a.paidByName, b.paidByName)), [funds]);
//   const totalResidents = residentFunds.reduce((sum, fund) => sum + (Number(fund.amount) || 0), 0);
//   const totalOther = otherFunds.reduce((sum, fund) => sum + (Number(fund.amount) || 0), 0);
// const downloadMembersExcel = () => {
//   const contributionFunds = funds.filter(
//     (fund) =>
//       (fund.sourceType || "resident") ===
//       "resident"
//   );

//   if (contributionFunds.length === 0) {
//     alert(
//       "No resident contribution records available"
//     );

//     return;
//   }

//   const rows = contributionFunds.map(
//     (fund, index) => {
//       const adults =
//         Number(
//           fund.householdCounts?.adults
//         ) || 0;

//       const kids =
//         Number(
//           fund.householdCounts?.kids
//         ) || 0;

//       const freeKids =
//         Number(
//           fund.householdCounts?.freeKids
//         ) || 0;

//       const chargeableKids = Math.max(
//         0,
//         kids - freeKids
//       );

//       const totalMembers =
//         adults + kids;

//       return {
//         "S.No": index + 1,

//         Block:
//           fund.blockName || "",

//         Floor:
//           fund.floorNumber ?? "",

//         Flat:
//           fund.flatLabel || "",

//         "Resident Name":
//           fund.paidByName || "",

//         Adults:
//           adults,

//         Kids:
//           chargeableKids,

//         "Free Kids":
//           freeKids,

//         // "Chargeable Kids":
//         //   chargeableKids,

//         "Total Members":
//           totalMembers,
//       };
//     }
//   );

//   const worksheet =
//     XLSX.utils.json_to_sheet(rows);

//   worksheet["!cols"] = [
//     {
//       wch: 8,
//     },
//     {
//       wch: 14,
//     },
//     {
//       wch: 12,
//     },
//     {
//       wch: 14,
//     },
//     {
//       wch: 28,
//     },
//     {
//       wch: 12,
//     },
//     {
//       wch: 12,
//     },
//     {
//       wch: 14,
//     },
//     {
//       wch: 18,
//     },
//     {
//       wch: 16,
//     },
//   ];

//   if (worksheet["!ref"]) {
//     worksheet["!autofilter"] = {
//       ref: worksheet["!ref"],
//     };
//   }

//   const workbook =
//     XLSX.utils.book_new();

//   XLSX.utils.book_append_sheet(
//     workbook,
//     worksheet,
//     "Flat Members"
//   );

//   const safeEventName = String(
//     event?.name ||
//       event?.title ||
//       "Event"
//   )
//     .trim()
//     .replace(/[\\/:*?"<>|]/g, "_")
//     .replace(/\s+/g, "_");

//   XLSX.writeFile(
//     workbook,
//     `Flat_Members_${safeEventName}.xlsx`
//   );
// };
  

//   const toggleOne = (id) => setSelectedFunds((previous) => previous.includes(id) ? previous.filter((item) => item !== id) : [...previous, id]);
//   const toggleAll = (list) => {
//     const ids = list.map((fund) => fund.id);
//     setSelectedFunds((previous) => ids.every((id) => previous.includes(id)) ? previous.filter((id) => !ids.includes(id)) : [...new Set([...previous, ...ids])]);
//   };

//   const deleteSelected = async () => {
//     if (!canEditFunds || !eventId || selectedFunds.length === 0) return;
//     if (!window.confirm(`Delete ${selectedFunds.length} selected record(s)?`)) return;
//     if (window.prompt("Type DELETE to continue") !== "DELETE") return alert("Delete cancelled.");
//     try {
//       setDeleting(true);
//       for (let start = 0; start < selectedFunds.length; start += 450) {
//         const batch = writeBatch(db);
//         selectedFunds.slice(start, start + 450).forEach((id) => batch.delete(doc(db, "events", eventId, "funds", id)));
//         await batch.commit();
//       }
//       setSelectedFunds([]);
//     } catch (deleteError) {
//       alert(deleteError?.message || "Failed to delete selected funds.");
//     } finally {
//       setDeleting(false);
//     }
//   };

//   const deleteOne = async (id) => {
//     if (!canEditFunds || !eventId || !window.confirm("Delete this fund entry?")) return;
//     try { await deleteDoc(doc(db, "events", eventId, "funds", id)); } catch (deleteError) { alert(deleteError?.message || "Failed to delete fund."); }
//   };

//   const openEdit = (fund) => {
//     setEditFund(fund);
//     setEditForm({ amount: String(fund.amount ?? ""), receiptNo: fund.receiptNo || "", method: fund.method || "", paidByName: fund.paidByName || "", receivedByName: fund.receivedByName || "", otherType: fund.otherType || "Donation", otherTitle: fund.otherTitle || "" });
//   };

//   const saveEdit = async () => {
//     const amount = Number(editForm.amount);
//     if (!editFund?.id || !Number.isFinite(amount) || amount <= 0) return alert("Enter a valid amount.");
//     try {
//       setSavingEdit(true);
//       await updateDoc(doc(db, "events", eventId, "funds", editFund.id), cleanObject({ amount, receiptNo: editForm.receiptNo.trim(), method: editForm.method, paidByName: editForm.paidByName.trim() || undefined, receivedByName: editForm.receivedByName.trim() || undefined, otherType: editFund.sourceType === "other" ? editForm.otherType : undefined, otherTitle: editFund.sourceType === "other" ? editForm.otherTitle.trim() || undefined : undefined, updatedAt: serverTimestamp() }));
//       setEditFund(null);
//     } catch (editError) {
//       alert(editError?.message || "Failed to update fund.");
//     } finally {
//       setSavingEdit(false);
//     }
//   };

//   return <div>
//     <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3"><strong>Funds Collection</strong><div className="d-flex flex-wrap gap-2"><Badge bg="secondary" className="p-2">Contributions: Rs. {fmt(totalResidents)}</Badge><Badge bg="info" className="p-2">Other: Rs. {fmt(totalOther)}</Badge><Badge bg="success" className="p-2">Total: Rs. {fmt(totalResidents + totalOther)}</Badge>{canEditFunds && <Button size="sm" onClick={() => setShowAdd(true)}>Add Funds</Button>} <Button
//   size="sm"
//   variant="success"
//   onClick={downloadMembersExcel}
// >
//   Download Excel
// </Button> {canEditFunds && <Button size="sm" variant="danger" disabled={deleting || selectedFunds.length === 0} onClick={deleteSelected}>{deleting ? "Deleting..." : `Delete Selected (${selectedFunds.length})`}</Button>}</div></div>
//     {error && <Alert variant="danger">{error}</Alert>}
//     {loading ? <Spinner size="sm" /> : <><FundTable title="Resident Contributions" funds={residentFunds} canEditFunds={canEditFunds} selectedFunds={selectedFunds} onSelect={toggleOne} onSelectAll={toggleAll} onReceipt={(fund) => generateFundReceipt({ fund, community, event, residents })} onEdit={openEdit} onDelete={deleteOne} /><FundTable title="Donations, Sponsors and Other Funds" funds={otherFunds} showType canEditFunds={canEditFunds} selectedFunds={selectedFunds} onSelect={toggleOne} onSelectAll={toggleAll} onReceipt={(fund) => generateFundReceipt({ fund, community, event, residents })} onEdit={openEdit} onDelete={deleteOne} /></>}

//     <Modal show={showAdd} onHide={() => setShowAdd(false)} size="xl" centered backdrop="static"><Modal.Header closeButton><Modal.Title>Add Funds</Modal.Title></Modal.Header><Modal.Body><Nav variant="tabs" activeKey={activeTab} onSelect={(key) => key && setActiveTab(key)} className="mb-4"><Nav.Item><Nav.Link eventKey="contribution">Contribution</Nav.Link></Nav.Item><Nav.Item><Nav.Link eventKey="donation">Donation / Sponsor / Other</Nav.Link></Nav.Item></Nav>{activeTab === "contribution" ? <FundContribution communityId={communityId} event={event} community={community} residents={residents} canEditFunds={canEditFunds} committeeOptions={committeeOptions} onClose={() => setShowAdd(false)} /> : <FundDonation communityId={communityId} event={event} community={community} residents={residents} canEditFunds={canEditFunds} committeeOptions={committeeOptions} onClose={() => setShowAdd(false)} />}</Modal.Body><Modal.Footer><Button variant="secondary" onClick={() => setShowAdd(false)}>Close</Button></Modal.Footer></Modal>

//     <Modal show={Boolean(editFund)} onHide={() => setEditFund(null)} centered><Modal.Header closeButton><Modal.Title>Edit Fund</Modal.Title></Modal.Header><Modal.Body>{editFund?.sourceType === "other" && <><Form.Label>Fund Type</Form.Label><Form.Select value={editForm.otherType} onChange={(e) => setEditForm((p) => ({ ...p, otherType: e.target.value }))}>{["Donation", "Sponsor", "Gift", "Sale", "Other"].map((type) => <option key={type}>{type}</option>)}</Form.Select><Form.Label className="mt-2">Purpose</Form.Label><Form.Control value={editForm.otherTitle} onChange={(e) => setEditForm((p) => ({ ...p, otherTitle: e.target.value }))} /></>}<Form.Label className="mt-2">Payer Name</Form.Label><Form.Control value={editForm.paidByName} onChange={(e) => setEditForm((p) => ({ ...p, paidByName: e.target.value }))} /><Form.Label className="mt-2">Amount</Form.Label><Form.Control type="number" value={editForm.amount} onChange={(e) => setEditForm((p) => ({ ...p, amount: e.target.value }))} /><Form.Label className="mt-2">Receipt No</Form.Label><Form.Control value={editForm.receiptNo} onChange={(e) => setEditForm((p) => ({ ...p, receiptNo: e.target.value }))} /><Form.Label className="mt-2">Pay Mode</Form.Label><Form.Select value={editForm.method} onChange={(e) => setEditForm((p) => ({ ...p, method: e.target.value }))}><option value="">Select Pay Mode</option>{PAYMENT_METHODS.map((method) => <option key={method}>{method}</option>)}</Form.Select><Form.Label className="mt-2">Received By</Form.Label><Form.Control value={editForm.receivedByName} onChange={(e) => setEditForm((p) => ({ ...p, receivedByName: e.target.value }))} /></Modal.Body><Modal.Footer><Button variant="secondary" onClick={() => setEditFund(null)}>Cancel</Button><Button onClick={saveEdit} disabled={savingEdit}>{savingEdit ? "Saving..." : "Save Changes"}</Button></Modal.Footer></Modal>
//   </div>;
// }

// function FundTable({ title, funds, showType = false, canEditFunds, selectedFunds, onSelect, onSelectAll, onReceipt, onEdit, onDelete }) {
//   const columnCount = 8 + (showType ? 2 : 0) + (canEditFunds ? 2 : 0);
//   return <Card className="mb-3"><Card.Header><strong>{title}</strong><Badge bg="primary" className="ms-2">{funds.length}</Badge></Card.Header><Card.Body className="p-0"><Table bordered hover responsive size="sm" className="mb-0"><thead><tr>{canEditFunds && <th><Form.Check checked={funds.length > 0 && funds.every((fund) => selectedFunds.includes(fund.id))} onChange={() => onSelectAll(funds)} /></th>}{showType && <><th>Type</th><th>Purpose</th></>}<th>Flat</th><th>Payer</th><th>Amount</th><th>Receipt</th><th>Method</th><th>Received By</th><th>PDF</th>{canEditFunds && <th>Actions</th>}</tr></thead><tbody>{funds.length === 0 ? <tr><td colSpan={columnCount} className="text-center">No funds yet</td></tr> : funds.map((fund) => <tr key={fund.id}>{canEditFunds && <td><Form.Check checked={selectedFunds.includes(fund.id)} onChange={() => onSelect(fund.id)} /></td>}{showType && <><td>{fund.otherType || "-"}</td><td
//   style={{
//     wordBreak: "break-word",
//     whiteSpace: "normal",
//   }}
// >
//   {fund.otherTitle || "-"}
// </td></>}<td style={{
//     whiteSpace: "nowrap",
//   }}>{fund.flatLabel || "-"}</td>
//   <td style={{
//     whiteSpace: "nowrap", width : "100px"
//   }} >{fund.paidByName || "-"}</td>
//   <td style={{
//     whiteSpace: "nowrap",
//   }}>₹ {fmt(fund.amount)}</td><td
//   style={{
//     whiteSpace: "nowrap",
//   }}
// >
//   {fund.receiptNo || "-"}
// </td>
// <td>{fund.method || "-"}</td><td style={{
//     whiteSpace: "nowrap",
//   }}>{fund.receivedByName || "-"}</td><td><Button size="sm" variant="outline-primary" onClick={() => onReceipt(fund)}>Receipt</Button></td>{canEditFunds && <td className="text-nowrap">
//   {/* <Button size="sm" variant="outline-secondary" onClick={() => onEdit(fund)}>Edit</Button>{" "}<Button size="sm" variant="outline-danger" onClick={() => onDelete(fund.id)}>Delete</Button> */}
//   <div className="d-flex gap-1">
//   <Button
//     size="sm"
//     variant="outline-secondary"
//     onClick={() => onEdit(fund)}
//   >
//     Edit
//   </Button>

//   <Button
//     size="sm"
//     variant="outline-danger"
//     onClick={() => onDelete(fund.id)}
//   >
//     Delete
//   </Button>
// </div>
//   </td>}
//   </tr>)}</tbody>
//   </Table></Card.Body></Card>;
// }

import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  Alert,
  Badge,
  Button,
  Card,
  Collapse,
  Form,
  Modal,
  Nav,
  Spinner,
  Table,
} from "react-bootstrap";

// import {
//   collection,
//   deleteDoc,
//   doc,
//   onSnapshot,
//   orderBy,
//   query,
//   serverTimestamp,
//   updateDoc,
//   writeBatch,
// } from "firebase/firestore";
import {
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
  writeBatch,
} from "firebase/firestore";

import { db } from "../../firebase";

import {
  cleanObject,
  fmt,
} from "../../utils/eventUtils";

import {
  generateFundReceipt,
} from "../../utils/generateFundReceipt";

import FundContribution from "./FundContribution";
import FundDonation from "./FundDonation";

const PAYMENT_METHODS = [
  "Cash",
  "PhonePe",
  "Google Pay",
  "UPI",
  "Bank Transfer",
];

const FUND_TYPES = [
  "Donation",
  "Sponsor",
  "Gift",
  "Sale",
  "Other",
];

const cmpStr = (first, second) =>
  String(first || "").localeCompare(
    String(second || ""),
    undefined,
    {
      sensitivity: "base",
      numeric: true,
    }
  );

  const normalizeText = (value) =>
  String(value ?? "")
    .trim()
    .toLowerCase();

export default function FundsPanel({
  communityId,
  event,
  community,
  residents = [],
  canEditFunds,
}) {
  const eventId = event?.id;

  const [funds, setFunds] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const [error, setError] =
    useState("");

  const [showAdd, setShowAdd] =
    useState(false);

  const [activeTab, setActiveTab] =
    useState("contribution");
    const [selectedBlock, setSelectedBlock] =
  useState("all");

const [
  selectedReceivedBy,
  setSelectedReceivedBy,
] = useState("all");

const [fundSearch, setFundSearch] =
  useState("");

  const [
    selectedFunds,
    setSelectedFunds,
  ] = useState([]);

  const [deleting, setDeleting] =
    useState(false);

  const [editFund, setEditFund] =
    useState(null);

  const [savingEdit, setSavingEdit] =
    useState(false);

    const [
  copyingReceiptLink,
  setCopyingReceiptLink,
] = useState(false);

const [
  receiptLinkCopied,
  setReceiptLinkCopied,
] = useState(false);

  const [editForm, setEditForm] =
    useState({
      amount: "",
      receiptNo: "",
      method: "",
      paidByName: "",
      receivedByName: "",
      otherType: "Donation",
      otherTitle: "",
    });

  useEffect(() => {
    if (!eventId) {
      setError("Missing event ID.");
      setLoading(false);

      return undefined;
    }

    setLoading(true);

    const fundsQuery = query(
      collection(
        db,
        "events",
        eventId,
        "funds"
      ),
      orderBy("createdAt", "desc")
    );

    return onSnapshot(
      fundsQuery,
      (snapshot) => {
        const loadedFunds =
          snapshot.docs.map(
            (documentSnapshot) => ({
              id: documentSnapshot.id,
              ...documentSnapshot.data(),
            })
          );

        setFunds(loadedFunds);
        setError("");
        setLoading(false);
      },
      (snapshotError) => {
        console.error(
          "Load funds error:",
          snapshotError
        );

        setError(
          snapshotError?.message ||
            "Failed to load funds."
        );

        setLoading(false);
      }
    );
  }, [eventId]);

  useEffect(() => {
    setSelectedFunds((previous) =>
      previous.filter((fundId) =>
        funds.some(
          (fund) => fund.id === fundId
        )
      )
    );
  }, [funds]);



  const residentNameByUid =
    useCallback(
      (uid, fallback = "") => {
        const resident =
          residents.find(
            (item) =>
              String(
                item?.uid ||
                  item?.id ||
                  ""
              ) ===
              String(uid || "")
          );

        return (
          resident?.fullName ||
          resident?.displayName ||
          resident?.name ||
          fallback ||
          uid ||
          ""
        );
      },
      [residents]
    );

  const committeeOptions = useMemo(
    () => {
      const options = new Map();

      const committeeMembers =
        Array.isArray(
          event?.committee
        )
          ? event.committee
          : [];

      committeeMembers.forEach(
        (member) => {
          const uid = String(
            member?.uid || ""
          ).trim();

          const suppliedName =
            String(
              member?.residentName ||
                member?.name ||
                member?.fullName ||
                member?.displayName ||
                ""
            ).trim();

          const label = uid
            ? residentNameByUid(
                uid,
                suppliedName
              )
            : suppliedName;

          const value = uid
            ? `uid:${uid}`
            : label
              ? `name:${label}`
              : "";

          if (
            value &&
            !options.has(value)
          ) {
            options.set(value, {
              value,
              uid,
              label,
            });
          }
        }
      );

      return [
        ...options.values(),
      ].sort((first, second) =>
        cmpStr(
          first.label,
          second.label
        )
      );
    },
    [
      event?.committee,
      residentNameByUid,
    ]
  );

  const residentFunds = useMemo(
    () =>
      funds
        .filter(
          (fund) =>
            (fund.sourceType ||
              "resident") ===
            "resident"
        )
        .sort(
          (first, second) =>
            cmpStr(
              first.blockName,
              second.blockName
            ) ||
            cmpStr(
              first.flatLabel,
              second.flatLabel
            )
        ),
    [funds]
  );

  const otherFunds = useMemo(
    () =>
      funds
        .filter(
          (fund) =>
            fund.sourceType ===
            "other"
        )
        .sort(
          (first, second) =>
            cmpStr(
              first.otherType,
              second.otherType
            ) ||
            cmpStr(
              first.paidByName,
              second.paidByName
            )
        ),
    [funds]
  );

  const blockOptions = useMemo(() => {
  const uniqueBlocks = new Map();
  

  funds.forEach((fund) => {
    const blockName = String(
      fund.blockName ||
        fund.block ||
        fund.unit?.blockName ||
        ""
    ).trim();

    if (!blockName) {
      return;
    }

    const blockKey =
      normalizeText(blockName);

    if (!uniqueBlocks.has(blockKey)) {
      uniqueBlocks.set(
        blockKey,
        blockName
      );
    }
  });

  return Array.from(
    uniqueBlocks.values()
  ).sort(cmpStr);
}, [funds]);


const receivedByOptions =
  useMemo(() => {
    const uniqueReceivers =
      new Map();

    funds.forEach((fund) => {
      const receivedByName =
        String(
          fund.receivedByName ||
          fund.receivedBy ||
          ""
        ).trim();

      if (!receivedByName) {
        return;
      }

      const receiverKey =
        normalizeText(
          receivedByName
        );

      if (
        !uniqueReceivers.has(
          receiverKey
        )
      ) {
        uniqueReceivers.set(
          receiverKey,
          receivedByName
        );
      }
    });

    return Array.from(
      uniqueReceivers.values()
    ).sort(cmpStr);
  }, [funds]);

  


      const matchesFundFilters =
  useCallback(
    (fund) => {
      const fundBlock =
        normalizeText(
          fund.blockName ||
            fund.block ||
            fund.unit?.blockName
        );

      const fundReceivedBy =
        normalizeText(
          fund.receivedByName ||
            fund.receivedBy
        );

      const normalizedSearch =
        normalizeText(
          fundSearch
        );

      const matchesBlock =
        selectedBlock === "all" ||
        fundBlock ===
          normalizeText(
            selectedBlock
          );

      const matchesReceivedBy =
        selectedReceivedBy ===
          "all" ||
        fundReceivedBy ===
          normalizeText(
            selectedReceivedBy
          );

      const searchableValues = [
        fund.blockName,
        fund.block,
        fund.flatLabel,
        fund.flatNumber,
        fund.paidByName,
        fund.receivedByName,
        fund.receiptNo,
        fund.method,
        fund.otherType,
        fund.otherTitle,
        fund.amount,
      ]
        .map(normalizeText)
        .join(" ");

      const matchesSearch =
        !normalizedSearch ||
        searchableValues.includes(
          normalizedSearch
        );

      return (
        matchesBlock &&
        matchesReceivedBy &&
        matchesSearch
      );
    },
    [
      selectedBlock,
      selectedReceivedBy,
      fundSearch,
    ]
  );

  const filteredResidentFunds =
  useMemo(
    () =>
      residentFunds.filter(
        matchesFundFilters
      ),
    [
      residentFunds,
      matchesFundFilters,
    ]
  );
  

  const filteredOtherFunds =
  useMemo(
    () =>
      otherFunds.filter(
        matchesFundFilters
      ),
    [
      otherFunds,
      matchesFundFilters,
    ]
  );

  const filteredResidentTotal =
  useMemo(
    () =>
      filteredResidentFunds.reduce(
        (total, fund) =>
          total +
          (Number(
            fund.amount
          ) || 0),
        0
      ),
    [filteredResidentFunds]
  );

const filteredOtherTotal =
  useMemo(
    () =>
      filteredOtherFunds.reduce(
        (total, fund) =>
          total +
          (Number(
            fund.amount
          ) || 0),
        0
      ),
    [filteredOtherFunds]
  );

const filteredGrandTotal =
  filteredResidentTotal +
  filteredOtherTotal;

const filteredRecordCount =
  filteredResidentFunds.length +
  filteredOtherFunds.length;

const filtersApplied =
  selectedBlock !== "all" ||
  selectedReceivedBy !== "all" ||
  normalizeText(fundSearch) !== "";

  useEffect(() => {
  const visibleFundIds = new Set([
    ...filteredResidentFunds.map(
      (fund) => fund.id
    ),
    ...filteredOtherFunds.map(
      (fund) => fund.id
    ),
  ]);

  setSelectedFunds(
    (previousSelectedFunds) =>
      previousSelectedFunds.filter(
        (fundId) =>
          visibleFundIds.has(fundId)
      )
  );
}, [
  filteredResidentFunds,
  filteredOtherFunds,
]);

  const totalResidents =
    useMemo(
      () =>
        residentFunds.reduce(
          (total, fund) =>
            total +
            (Number(fund.amount) ||
              0),
          0
        ),
      [residentFunds]
    );

  const totalOther = useMemo(
    () =>
      otherFunds.reduce(
        (total, fund) =>
          total +
          (Number(fund.amount) ||
            0),
        0
      ),
    [otherFunds]
  );

  const toggleOne = useCallback(
    (fundId) => {
      if (!fundId) {
        return;
      }

      setSelectedFunds(
        (previous) => {
          if (
            previous.includes(fundId)
          ) {
            return previous.filter(
              (item) =>
                item !== fundId
            );
          }

          return [
            ...previous,
            fundId,
          ];
        }
      );
    },
    []
  );

  const toggleAll = useCallback(
    (fundList) => {
      const safeFundList =
        Array.isArray(fundList)
          ? fundList
          : [];

      const fundIds =
        safeFundList
          .map((fund) => fund.id)
          .filter(Boolean);

      setSelectedFunds(
        (previous) => {
          const allSelected =
            fundIds.length > 0 &&
            fundIds.every((fundId) =>
              previous.includes(
                fundId
              )
            );

          if (allSelected) {
            return previous.filter(
              (fundId) =>
                !fundIds.includes(
                  fundId
                )
            );
          }

          return [
            ...new Set([
              ...previous,
              ...fundIds,
            ]),
          ];
        }
      );
    },
    []
  );

  const deleteSelected =
    async () => {
      if (!canEditFunds) {
        alert(
          "You are not allowed to delete funds."
        );
        return;
      }

      if (!eventId) {
        alert(
          "Event ID is missing."
        );
        return;
      }

      if (
        selectedFunds.length === 0
      ) {
        alert(
          "Select at least one record."
        );
        return;
      }

      const confirmed =
        window.confirm(
          `Delete ${selectedFunds.length} selected record(s)?`
        );

      if (!confirmed) {
        return;
      }

      const deleteText =
        window.prompt(
          "Type DELETE to continue"
        );

      if (
        String(deleteText || "")
          .trim()
          .toUpperCase() !==
        "DELETE"
      ) {
        alert(
          "Delete cancelled."
        );
        return;
      }

      try {
        setDeleting(true);

        for (
          let start = 0;
          start <
          selectedFunds.length;
          start += 450
        ) {
          const batch =
            writeBatch(db);

          const currentIds =
            selectedFunds.slice(
              start,
              start + 450
            );

          currentIds.forEach(
            (fundId) => {
              batch.delete(
                doc(
                  db,
                  "events",
                  eventId,
                  "funds",
                  fundId
                )
              );
            }
          );

          await batch.commit();
        }

        setSelectedFunds([]);

        alert(
          "Selected fund records deleted successfully."
        );
      } catch (deleteError) {
        console.error(
          "Delete selected funds error:",
          deleteError
        );

        alert(
          deleteError?.message ||
            "Failed to delete selected funds."
        );
      } finally {
        setDeleting(false);
      }
    };

  const deleteOne = async (
    fundId
  ) => {
    if (!canEditFunds) {
      alert(
        "You are not allowed to delete funds."
      );
      return;
    }

    if (!eventId || !fundId) {
      alert(
        "Event or fund ID is missing."
      );
      return;
    }

    const confirmed =
      window.confirm(
        "Delete this fund entry?"
      );

    if (!confirmed) {
      return;
    }

    try {
      await deleteDoc(
        doc(
          db,
          "events",
          eventId,
          "funds",
          fundId
        )
      );
    } catch (deleteError) {
      console.error(
        "Delete fund error:",
        deleteError
      );

      alert(
        deleteError?.message ||
          "Failed to delete fund."
      );
    }
  };

  const openEdit = (fund) => {
    setEditFund(fund);

    setEditForm({
      amount: String(
        fund?.amount ?? ""
      ),

      receiptNo:
        fund?.receiptNo || "",

      method:
        fund?.method || "",

      paidByName:
        fund?.paidByName || "",

      receivedByName:
        fund?.receivedByName ||
        "",

      otherType:
        fund?.otherType ||
        "Donation",

      otherTitle:
        fund?.otherTitle || "",
    });
  };

  const closeEdit = () => {
    if (savingEdit) {
      return;
    }

    setEditFund(null);
  };

  const saveEdit = async () => {
    if (!canEditFunds) {
      alert(
        "You are not allowed to edit funds."
      );
      return;
    }

    if (
      !eventId ||
      !editFund?.id
    ) {
      alert(
        "Event or fund ID is missing."
      );
      return;
    }

    const amount = Number(
      editForm.amount
    );

    if (
      !Number.isFinite(amount) ||
      amount <= 0
    ) {
      alert(
        "Enter a valid amount."
      );
      return;
    }

    if (!editForm.method) {
      alert(
        "Select pay mode."
      );
      return;
    }

    try {
      setSavingEdit(true);

      const isOtherFund =
        editFund.sourceType ===
        "other";

      await updateDoc(
        doc(
          db,
          "events",
          eventId,
          "funds",
          editFund.id
        ),
        cleanObject({
          amount,

          receiptNo: String(
            editForm.receiptNo ||
              ""
          ).trim(),

          method:
            editForm.method,

          paidByName:
            String(
              editForm.paidByName ||
                ""
            ).trim() ||
            undefined,

          receivedByName:
            String(
              editForm.receivedByName ||
                ""
            ).trim() ||
            undefined,

          otherType:
            isOtherFund
              ? editForm.otherType
              : undefined,

          otherTitle:
            isOtherFund
              ? String(
                  editForm.otherTitle ||
                    ""
                ).trim() ||
                undefined
              : undefined,

          updatedAt:
            serverTimestamp(),
        })
      );

      setEditFund(null);
    } catch (editError) {
      console.error(
        "Update fund error:",
        editError
      );

      alert(
        editError?.message ||
          "Failed to update fund."
      );
    } finally {
      setSavingEdit(false);
    }
  };

  const downloadReceipt =
    useCallback(
      (fund) => {
        try {
          generateFundReceipt({
            fund,
            community,
            event,
            residents,
          });
        } catch (receiptError) {
          console.error(
            "Receipt generation error:",
            receiptError
          );

          alert(
            receiptError?.message ||
              "Failed to generate receipt."
          );
        }
      },
      [
        community,
        event,
        residents,
      ]
    );

    const copyEventReceiptLink =
  useCallback(async () => {
    const safeEventId = String(
      eventId || ""
    ).trim();

    const safeCommunityId = String(
      communityId || ""
    ).trim();

    if (!safeEventId) {
      alert("Event ID is missing.");
      return;
    }

    if (!safeCommunityId) {
      alert("Community ID is missing.");
      return;
    }

    try {
      setCopyingReceiptLink(true);
      setReceiptLinkCopied(false);

      const receiptUrl = new URL(
        `/download-receipt/${encodeURIComponent(
          safeEventId
        )}`,
        window.location.origin
      );

      receiptUrl.searchParams.set(
        "communityId",
        safeCommunityId
      );

      const finalReceiptUrl =
        receiptUrl.toString();

      if (
        navigator.clipboard &&
        window.isSecureContext
      ) {
        await navigator.clipboard.writeText(
          finalReceiptUrl
        );
      } else {
        const temporaryTextArea =
          document.createElement(
            "textarea"
          );

        temporaryTextArea.value =
          finalReceiptUrl;

        temporaryTextArea.setAttribute(
          "readonly",
          ""
        );

        temporaryTextArea.style.position =
          "fixed";

        temporaryTextArea.style.left =
          "-9999px";

        temporaryTextArea.style.top =
          "-9999px";

        document.body.appendChild(
          temporaryTextArea
        );

        temporaryTextArea.focus();
        temporaryTextArea.select();

        temporaryTextArea.setSelectionRange(
          0,
          temporaryTextArea.value.length
        );

        const copied =
          document.execCommand("copy");

        document.body.removeChild(
          temporaryTextArea
        );

        if (!copied) {
          throw new Error(
            "The browser could not copy the receipt link."
          );
        }
      }

      setReceiptLinkCopied(true);

      window.setTimeout(() => {
        setReceiptLinkCopied(false);
      }, 3000);
    } catch (copyError) {
      console.error(
        "Copy receipt link error:",
        copyError
      );

      alert(
        copyError?.message ||
          "Unable to copy the receipt link."
      );
    } finally {
      setCopyingReceiptLink(false);
    }
  }, [communityId, eventId]);

  const resetFundFilters =
  useCallback(() => {
    setSelectedBlock("all");
    setSelectedReceivedBy("all");
    setFundSearch("");
  }, []);


  const openAddModal = () => {
    setActiveTab(
      "contribution"
    );

    setShowAdd(true);
  };

  const closeAddModal = () => {
    setShowAdd(false);
  };

  

  return (
    <div className="funds-panel">
      <Card className="mb-3 shadow-sm">
        <Card.Body>
          <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3">
            <div>
              <h5 className="mb-1">
                Funds Collection
              </h5>

              <small className="text-muted">
                Manage contributions,
                donations, sponsors,
                receipts, and fund
                records.
              </small>
            </div>

            <div className="d-flex flex-wrap gap-2">
              <Badge
                bg="secondary"
                className="p-2"
              >
                Contributions: Rs.{" "}
                {fmt(
                  totalResidents
                )}
              </Badge>

              <Badge
                bg="info"
                className="p-2"
              >
                Other: Rs.{" "}
                {fmt(totalOther)}
              </Badge>

              <Badge
                bg="success"
                className="p-2"
              >
                Total: Rs.{" "}
                {fmt(
                  totalResidents +
                    totalOther
                )}
              </Badge>
            </div>
          </div>

        {canEditFunds && (
  <div className="d-flex flex-column flex-sm-row flex-wrap gap-2 mt-3">
    <Button
      type="button"
      size="sm"
      variant="primary"
      onClick={openAddModal}
    >
      Add Funds
    </Button>

    <Button
      type="button"
      size="sm"
      variant={
        receiptLinkCopied
          ? "success"
          : "outline-primary"
      }
      disabled={
        copyingReceiptLink ||
        !eventId ||
        !communityId
      }
      onClick={copyEventReceiptLink}
    >
      {copyingReceiptLink ? (
        <>
          <Spinner
            animation="border"
            size="sm"
            className="me-2"
          />
          Copying...
        </>
      ) : receiptLinkCopied ? (
        "Receipt Link Copied"
      ) : (
        "Copy Receipt Link"
      )}
    </Button>

    <Button
      type="button"
      size="sm"
      variant="danger"
      disabled={
        deleting ||
        selectedFunds.length === 0
      }
      onClick={deleteSelected}
    >
      {deleting ? (
        <>
          <Spinner
            animation="border"
            size="sm"
            className="me-2"
          />
          Deleting...
        </>
      ) : (
        `Delete Selected (${selectedFunds.length})`
      )}
    </Button>
  </div>
)}

        </Card.Body>

        </Card>

        <Card className="mb-3 shadow-sm">
  <Card.Header>
    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
      <strong>Filter Funds</strong>

      {filtersApplied && (
        <Badge bg="primary">
          {filteredRecordCount}{" "}
          record
          {filteredRecordCount === 1
            ? ""
            : "s"}
        </Badge>
      )}
    </div>
  </Card.Header>

  <Card.Body>
    <div className="row g-3">
      <div className="col-12 col-md-4">
        <Form.Group controlId="fundBlockFilter">
          <Form.Label>
            Block
          </Form.Label>

          <Form.Select
            value={selectedBlock}
            onChange={(event) =>
              setSelectedBlock(
                event.target.value
              )
            }
          >
            <option value="all">
              All Blocks
            </option>

            {blockOptions.map(
              (blockName) => (
                <option
                  key={blockName}
                  value={blockName}
                >
                  {blockName}
                </option>
              )
            )}
          </Form.Select>
        </Form.Group>
      </div>

      <div className="col-12 col-md-4">
        <Form.Group controlId="fundReceivedByFilter">
          <Form.Label>
            Received By
          </Form.Label>

          <Form.Select
            value={
              selectedReceivedBy
            }
            onChange={(event) =>
              setSelectedReceivedBy(
                event.target.value
              )
            }
          >
            <option value="all">
              All Receivers
            </option>

            {receivedByOptions.map(
              (receivedByName) => (
                <option
                  key={
                    receivedByName
                  }
                  value={
                    receivedByName
                  }
                >
                  {receivedByName}
                </option>
              )
            )}
          </Form.Select>
        </Form.Group>
      </div>

      <div className="col-12 col-md-4">
        <Form.Group controlId="fundSearch">
          <Form.Label>
            Search
          </Form.Label>

          <Form.Control
            type="search"
            value={fundSearch}
            placeholder="Payer, flat, receipt, purpose..."
            onChange={(event) =>
              setFundSearch(
                event.target.value
              )
            }
          />
        </Form.Group>
      </div>
    </div>

    <div className="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center gap-3 mt-3">
      <div className="d-flex flex-wrap gap-2">
        <Badge
          bg="secondary"
          className="p-2"
        >
          Resident: Rs.{" "}
          {fmt(
            filteredResidentTotal
          )}
        </Badge>

        <Badge
          bg="info"
          className="p-2"
        >
          Other: Rs.{" "}
          {fmt(
            filteredOtherTotal
          )}
        </Badge>

        <Badge
          bg="success"
          className="p-2"
        >
          Filtered Total: Rs.{" "}
          {fmt(
            filteredGrandTotal
          )}
        </Badge>
      </div>

      <Button
        type="button"
        size="sm"
        variant="outline-secondary"
        disabled={!filtersApplied}
        onClick={resetFundFilters}
      >
        Clear Filters
      </Button>
    </div>
  </Card.Body>
</Card>

      {/* </Card> */}

      {error && (
        <Alert variant="danger">
          {error}
        </Alert>
      )}

      {loading ? (
        <div className="text-center py-5">
          <Spinner
            animation="border"
            variant="primary"
          />

          <div className="mt-2 text-muted">
            Loading funds...
          </div>
        </div>
      ) : (
        <>
          {/* <ResponsiveFundTable
            title="Resident Contributions"
            funds={
              residentFunds
            }
            showType={false}
            canEditFunds={
              canEditFunds
            }
            selectedFunds={
              selectedFunds
            }
            onSelect={toggleOne}
            onSelectAll={
              toggleAll
            }
            onReceipt={
              downloadReceipt
            }
            onEdit={openEdit}
            onDelete={deleteOne} */}
            {/* <ResponsiveFundTable
  title="Resident Contributions"
  funds={
    filteredResidentFunds
  }
          /> */}
          <ResponsiveFundTable
  title="Resident Contributions"
  funds={
    filteredResidentFunds
  }
  showType={false}
  canEditFunds={
    canEditFunds
  }
  selectedFunds={
    selectedFunds
  }
  onSelect={toggleOne}
  onSelectAll={
    toggleAll
  }
  onReceipt={
    downloadReceipt
  }
  onEdit={openEdit}
  onDelete={deleteOne}
/>

          {/* <ResponsiveFundTable
            title="Donations, Sponsors and Other Funds"
            funds={otherFunds} */}
            <ResponsiveFundTable
  title="Donations, Sponsors and Other Funds"
  funds={
    filteredOtherFunds
  }
            showType
            canEditFunds={
              canEditFunds
            }
            selectedFunds={
              selectedFunds
            }
            onSelect={toggleOne}
            onSelectAll={
              toggleAll
            }
            onReceipt={
              downloadReceipt
            }
            onEdit={openEdit}
            onDelete={deleteOne}
          />
        </>
      )}

      <Modal
        show={showAdd}
        onHide={closeAddModal}
        size="xl"
        centered
        backdrop="static"
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Add Funds
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Nav
            variant="tabs"
            activeKey={activeTab}
            onSelect={(key) => {
              if (key) {
                setActiveTab(key);
              }
            }}
            className="mb-4 flex-nowrap overflow-auto"
          >
            <Nav.Item>
              <Nav.Link eventKey="contribution">
                Contribution
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="donation">
                Donation / Sponsor /
                Other
              </Nav.Link>
            </Nav.Item>
          </Nav>

          {activeTab ===
          "contribution" ? (
            <FundContribution
              communityId={
                communityId
              }
              event={event}
              community={community}
              residents={residents}
              canEditFunds={
                canEditFunds
              }
              committeeOptions={
                committeeOptions
              }
              onClose={
                closeAddModal
              }
            />
          ) : (
            <FundDonation
              communityId={
                communityId
              }
              event={event}
              community={community}
              residents={residents}
              canEditFunds={
                canEditFunds
              }
              committeeOptions={
                committeeOptions
              }
              onClose={
                closeAddModal
              }
            />
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            type="button"
            variant="secondary"
            onClick={
              closeAddModal
            }
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={Boolean(editFund)}
        onHide={closeEdit}
        centered
        backdrop="static"
      >
        <Modal.Header
          closeButton={!savingEdit}
        >
          <Modal.Title>
            Edit Fund
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {editFund?.sourceType ===
            "other" && (
            <>
              <Form.Group className="mb-3">
                <Form.Label>
                  Fund Type
                </Form.Label>

                <Form.Select
                  value={
                    editForm.otherType
                  }
                  onChange={(event) =>
                    setEditForm(
                      (previous) => ({
                        ...previous,
                        otherType:
                          event.target
                            .value,
                      })
                    )
                  }
                >
                  {FUND_TYPES.map(
                    (type) => (
                      <option
                        key={type}
                        value={type}
                      >
                        {type}
                      </option>
                    )
                  )}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>
                  Purpose
                </Form.Label>

                <Form.Control
                  type="text"
                  value={
                    editForm.otherTitle
                  }
                  onChange={(event) =>
                    setEditForm(
                      (previous) => ({
                        ...previous,
                        otherTitle:
                          event.target
                            .value,
                      })
                    )
                  }
                />
              </Form.Group>
            </>
          )}

          <Form.Group className="mb-3">
            <Form.Label>
              Payer Name
            </Form.Label>

            <Form.Control
              type="text"
              value={
                editForm.paidByName
              }
              onChange={(event) =>
                setEditForm(
                  (previous) => ({
                    ...previous,
                    paidByName:
                      event.target
                        .value,
                  })
                )
              }
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>
              Amount
            </Form.Label>

            <Form.Control
              type="number"
              min="0"
              step="0.01"
              value={
                editForm.amount
              }
              onChange={(event) =>
                setEditForm(
                  (previous) => ({
                    ...previous,
                    amount:
                      event.target
                        .value,
                  })
                )
              }
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>
              Receipt Number
            </Form.Label>

            <Form.Control
              type="text"
              value={
                editForm.receiptNo
              }
              onChange={(event) =>
                setEditForm(
                  (previous) => ({
                    ...previous,
                    receiptNo:
                      event.target
                        .value,
                  })
                )
              }
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>
              Pay Mode
            </Form.Label>

            <Form.Select
              value={
                editForm.method
              }
              onChange={(event) =>
                setEditForm(
                  (previous) => ({
                    ...previous,
                    method:
                      event.target
                        .value,
                  })
                )
              }
            >
              <option value="">
                Select Pay Mode
              </option>

              {PAYMENT_METHODS.map(
                (method) => (
                  <option
                    key={method}
                    value={method}
                  >
                    {method}
                  </option>
                )
              )}
            </Form.Select>
          </Form.Group>

          <Form.Group>
            <Form.Label>
              Received By
            </Form.Label>

            <Form.Control
              type="text"
              value={
                editForm.receivedByName
              }
              onChange={(event) =>
                setEditForm(
                  (previous) => ({
                    ...previous,
                    receivedByName:
                      event.target
                        .value,
                  })
                )
              }
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer className="d-flex flex-column flex-sm-row">
          <Button
            type="button"
            variant="secondary"
            className="w-100 w-sm-auto"
            disabled={savingEdit}
            onClick={closeEdit}
          >
            Cancel
          </Button>

          <Button
            type="button"
            variant="primary"
            className="w-100 w-sm-auto"
            disabled={savingEdit}
            onClick={saveEdit}
          >
            {savingEdit ? (
              <>
                <Spinner
                  animation="border"
                  size="sm"
                  className="me-2"
                />
                Saving...
              </>
            ) : (
              "Save Changes"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

function ResponsiveFundTable({
  title,
  funds = [],
  showType = false,
  canEditFunds,
  selectedFunds = [],
  onSelect,
  onSelectAll,
  onReceipt,
  onEdit,
  onDelete,
}) {
  const [
    expandedRows,
    setExpandedRows,
  ] = useState([]);

  useEffect(() => {
    setExpandedRows((previous) =>
      previous.filter((fundId) =>
        funds.some(
          (fund) => fund.id === fundId
        )
      )
    );
  }, [funds]);

  const allSelected =
    funds.length > 0 &&
    funds.every((fund) =>
      selectedFunds.includes(
        fund.id
      )
    );

  const toggleExpandedRow = (
    fundId
  ) => {
    setExpandedRows(
      (previous) => {
        if (
          previous.includes(fundId)
        ) {
          return previous.filter(
            (item) =>
              item !== fundId
          );
        }

        return [
          ...previous,
          fundId,
        ];
      }
    );
  };

  const columnCount =
    8 +
    (showType ? 2 : 0) +
    (canEditFunds ? 2 : 0);

  return (
    <Card className="mb-3 shadow-sm">
      <Card.Header>
        <div className="d-flex justify-content-between align-items-center gap-2">
          <div>
            <strong>{title}</strong>

            <Badge
              bg="primary"
              className="ms-2"
            >
              {funds.length}
            </Badge>
          </div>

          {canEditFunds &&
            funds.length > 0 && (
              <Form.Check
                type="checkbox"
                id={`select-all-${title
                  .replace(/\s+/g, "-")
                  .toLowerCase()}`}
                label="Select all"
                checked={
                  allSelected
                }
                onChange={() =>
                  onSelectAll(funds)
                }
                className="d-md-none mb-0"
              />
            )}
        </div>
      </Card.Header>

      <Card.Body className="p-0">
        <div className="d-none d-md-block">
          <DesktopFundTable
            funds={funds}
            showType={showType}
            canEditFunds={
              canEditFunds
            }
            selectedFunds={
              selectedFunds
            }
            allSelected={
              allSelected
            }
            columnCount={
              columnCount
            }
            onSelect={onSelect}
            onSelectAll={
              onSelectAll
            }
            onReceipt={
              onReceipt
            }
            onEdit={onEdit}
            onDelete={onDelete}
          />
        </div>

        <div className="d-md-none">
          {funds.length === 0 ? (
            <div className="text-center text-muted py-4">
              No funds yet
            </div>
          ) : (
            funds.map((fund) => (
              <MobileFundRow
                key={fund.id}
                fund={fund}
                showType={
                  showType
                }
                canEditFunds={
                  canEditFunds
                }
                selected={
                  selectedFunds.includes(
                    fund.id
                  )
                }
                expanded={
                  expandedRows.includes(
                    fund.id
                  )
                }
                onSelect={() =>
                  onSelect(fund.id)
                }
                onToggle={() =>
                  toggleExpandedRow(
                    fund.id
                  )
                }
                onReceipt={() =>
                  onReceipt(fund)
                }
                onEdit={() =>
                  onEdit(fund)
                }
                onDelete={() =>
                  onDelete(fund.id)
                }
              />
            ))
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

function DesktopFundTable({
  funds,
  showType,
  canEditFunds,
  selectedFunds,
  allSelected,
  columnCount,
  onSelect,
  onSelectAll,
  onReceipt,
  onEdit,
  onDelete,
}) {
  return (
    <Table
      bordered
      hover
      responsive
      size="sm"
      className="mb-0 align-middle"
    >
      <thead className="table-light">
        <tr>
          {canEditFunds && (
            <th
              className="text-center"
              style={{
                width: "48px",
              }}
            >
              <Form.Check
                type="checkbox"
                checked={
                  allSelected
                }
                onChange={() =>
                  onSelectAll(funds)
                }
                aria-label="Select all fund records"
              />
            </th>
          )}
            <th>S.No</th>

          {showType && (
            <>
              <th>Type</th>
              <th>Purpose</th>
            </>
          )}

        
<th>Block</th>
          <th>Flat</th>
          <th>Payer</th>
          <th>Amount</th>
          <th>Receipt</th>
          <th>Method</th>
          <th>Received By</th>
          <th>PDF</th>

          {canEditFunds && (
            <th>Actions</th>
          )}
        </tr>
      </thead>

      <tbody>
        {funds.length === 0 ? (
          <tr>
            <td
              colSpan={columnCount}
              className="text-center text-muted py-4"
            >
              No funds yet
            </td>
          </tr>
        ) : (
          funds.map((fund, index) => (
            <tr key={fund.id}>
              {canEditFunds && (
                <td className="text-center">
                  <Form.Check
                    type="checkbox"
                    checked={selectedFunds.includes(
                      fund.id
                    )}
                    onChange={() =>
                      onSelect(
                        fund.id
                      )
                    }
                    aria-label={`Select receipt ${
                      fund.receiptNo ||
                      fund.id
                    }`}
                  />
                </td>
              )}

              <td className="text-center">
{index + 1}
</td>

              {showType && (
                <>
                  <td>
                    <Badge bg="secondary">
                      {fund.otherType ||
                        "Other"}
                    </Badge>
                  </td>

                  <td>
                    {fund.otherTitle ||
                      "-"}
                  </td>
                </>
              )}

              <td>
                {fund.blockName ||
                  "-"}
              </td>

              <td className="text-nowrap">
                {fund.flatLabel ||
                  "-"}
              </td>

              <td>
                {fund.paidByName ||
                  "-"}
              </td>

              <td className="text-nowrap">
                Rs.{" "}
                {fmt(
                  fund.amount
                )}
              </td>

              <td className="text-nowrap">
                {fund.receiptNo ||
                  "-"}
              </td>

              <td>
                {fund.method || "-"}
              </td>

              <td>
                {fund.receivedByName ||
                  "-"}
              </td>

              <td>
                <Button
                  type="button"
                  size="sm"
                  variant="outline-primary"
                  onClick={() =>
                    onReceipt(fund)
                  }
                >
                  Receipt
                </Button>
              </td>

              {canEditFunds && (
                <td className="text-nowrap">
                  <Button
                    type="button"
                    size="sm"
                    variant="outline-secondary"
                    onClick={() =>
                      onEdit(fund)
                    }
                  >
                    Edit
                  </Button>

                  <Button
                    type="button"
                    size="sm"
                    variant="outline-danger"
                    className="ms-1"
                    onClick={() =>
                      onDelete(
                        fund.id
                      )
                    }
                  >
                    Delete
                  </Button>
                </td>
              )}
            </tr>
          ))
        )}
      </tbody>
    </Table>
  );
}

function MobileFundRow({
  fund,
  showType,
  canEditFunds,
  selected,
  expanded,
  onSelect,
  onToggle,
  onReceipt,
  onEdit,
  onDelete,
}) {
  const householdCounts =
    fund?.householdCounts ||
    {};

  const adults =
    Number(
      householdCounts.adults
    ) || 0;

  const kids =
    Number(
      householdCounts.kids
    ) || 0;

  const freeKids =
    Number(
      householdCounts.freeKids ??
        householdCounts.infants
    ) || 0;

  const totalMembers =
    Number(
      householdCounts.totalMembers
    ) ||
    adults + kids;

  return (
    <div className="border-bottom">
      <div className="p-3">
        <div className="d-flex align-items-start gap-2">
          {canEditFunds && (
            <Form.Check
              type="checkbox"
              checked={selected}
              onChange={onSelect}
              className="mt-1"
              aria-label={`Select ${
                fund.receiptNo ||
                fund.id
              }`}
            />
          )}

          <div className="flex-grow-1 min-w-0">
            <div className="d-flex justify-content-between align-items-start gap-2">
              <div className="min-w-0">
                <strong className="d-block text-break">
                  {fund.paidByName ||
                    "Payer not available"}
                </strong>

                <small className="text-muted">
                  {fund.blockName ||
                    "-"}
                  {" / "}
                  {fund.flatLabel ||
                    "-"}
                </small>
              </div>

              <strong className="text-success text-nowrap">
                Rs.{" "}
                {fmt(
                  fund.amount
                )}
              </strong>
            </div>

            <div className="d-flex flex-wrap gap-2 mt-2">
              {showType && (
                <Badge bg="secondary">
                  {fund.otherType ||
                    "Other"}
                </Badge>
              )}

              {/* <Badge bg="light" text="dark">
                Receipt:{" "}
                {fund.receiptNo ||
                  "-"}
              </Badge>

              <Badge bg="light" text="dark">
                {fund.method ||
                  "No payment mode"}
              </Badge> */}
            </div>

            <Button
              type="button"
              variant="link"
              size="sm"
              className="px-0 mt-2 text-decoration-none"
              aria-expanded={
                expanded
              }
              aria-controls={`mobile-fund-details-${fund.id}`}
              onClick={onToggle}
            >
              {expanded
                ? "Hide Details"
                : "View Details"}

              <span
                className="ms-1"
                aria-hidden="true"
              >
                {expanded
                  ? "▲"
                  : "▼"}
              </span>
            </Button>
          </div>
        </div>

        <Collapse in={expanded}>
          <div
            id={`mobile-fund-details-${fund.id}`}
          >
            <div className="bg-light rounded p-3 mt-2">
              {showType && (
                <>
                  <MobileDetail
                    label="Fund Type"
                    value={
                      fund.otherType ||
                      "-"
                    }
                  />

                  <MobileDetail
                    label="Purpose"
                    value={
                      fund.otherTitle ||
                      "-"
                    }
                  />
                </>
              )}

              <MobileDetail
                label="Block"
                value={
                  fund.blockName ||
                  "-"
                }
              />

              <MobileDetail
                label="Flat"
                value={
                  fund.flatLabel ||
                  "-"
                }
              />

              <MobileDetail
                label="Payer"
                value={
                  fund.paidByName ||
                  "-"
                }
              />

              <MobileDetail
                label="Amount"
                value={`Rs. ${fmt(
                  fund.amount
                )}`}
              />

              <MobileDetail
                label="Receipt Number"
                value={
                  fund.receiptNo ||
                  "-"
                }
              />

              <MobileDetail
                label="Payment Method"
                value={
                  fund.method || "-"
                }
              />

              <MobileDetail
                label="Received By"
                value={
                  fund.receivedByName ||
                  "-"
                }
              />

              {!showType &&
                fund.householdCounts && (
                  <>
                    <hr className="my-2" />

                    <div className="fw-semibold mb-2">
                      Member Counts
                    </div>

                    <div className="d-flex flex-wrap gap-2">
                      <Badge bg="secondary">
                        Adults:{" "}
                        {adults}
                      </Badge>

                      <Badge bg="info">
                        Kids: {kids}
                      </Badge>

                      <Badge
                        bg="warning"
                        text="dark"
                      >
                        Infants:{" "}
                        {freeKids}
                      </Badge>

                      <Badge bg="dark">
                        Total:{" "}
                        {totalMembers}
                      </Badge>
                    </div>
                  </>
                )}

              <div className="d-grid gap-2 mt-3">
                <Button
                  type="button"
                  size="sm"
                  variant="outline-primary"
                  onClick={
                    onReceipt
                  }
                >
                  Download Receipt
                </Button>

                {canEditFunds && (
                  <>
                    <Button
                      type="button"
                      size="sm"
                      variant="outline-secondary"
                      onClick={
                        onEdit
                      }
                    >
                      Edit Fund
                    </Button>

                    <Button
                      type="button"
                      size="sm"
                      variant="outline-danger"
                      onClick={
                        onDelete
                      }
                    >
                      Delete Fund
                    </Button>
                  </>
                )}
              </div>
            </div>
          </div>
        </Collapse>
      </div>
    </div>
  );
}

function MobileDetail({
  label,
  value,
}) {
  return (
    <div className="d-flex justify-content-between align-items-start gap-3 py-1">
      <span className="text-muted">
        {label}
      </span>

      <span className="fw-medium text-end text-break">
        {value}
      </span>
    </div>
  );
}